import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable, of} from 'rxjs';
import {User} from '../model/user';
import {Bot} from '../model/bot';
import {PagedData} from '../model/paged-data';
import {ContentListDto} from '../model/content-list-dto';
import {QuestionnairesListDto} from '../model/questionnaires-list-dto';
import {ActionListDto} from '../model/action-list-dto';
import {DialogueListDto} from '../model/dialogue-list-dto';
import {ConversationListDto} from '../model/conversation-list-dto';
import {TopicListDto} from '../model/topic-list-dto';
import {EventListDto} from '../model/event-list-dto';
import {MessageShowType} from '../model/message-show-type.enum';
import {Message} from '../model/message';
import {Dialogue} from '../model/dialogue';
import {Picture} from '../model/picture';
import {StringResponse} from '../model/string-response';
import {ContentDto} from '../model/content-dto';
import {UtteranceDto} from '../model/utterance-dto';
import {ActionConfidenceDto} from '../model/action-confidence-dto';
import {ActionDto} from '../model/action-dto';
import {Dictionary} from '../model/dictionary';
import {Media} from '../model/media';
import {SlotFilingFormDto} from '../model/slot-filing-form-dto';
import {ManagementSummaryDto} from '../model/management-summary-dto';
import {SlotDto} from '../model/slot-dto';
import {ParameterDto} from '../model/parameter-dto';
import {AllowParameterValueDto} from '../model/allow-parameter-value-dto';
import {UserDto} from '../model/user-dto';
import {ContentFilter} from '../model/content-filter';
import {ContentListRequest} from '../model/content-list-request';
import {MediaDto} from '../model/media-dto';
import {MediaSetDto} from '../model/media-set-dto';
import {ActionGroupDto} from '../model/action-group-dto';
import {BotDashboard} from '../model/bot-dashboard';
import {GraphModel} from '../model/graph-model';
import {FileDto} from '../model/file-dto';
import {VActionConfidenceDto} from '../model/vaction-confidence-dto';
import {MessageIntentListDto} from '../model/message-intent-list-dto';
import {SlotListDto} from '../model/slot-list-dto';
import {SlotFormClearRequest} from '../model/slot-form-clear-request';
import {SlotPhrasesDto} from '../model/slot-phrases-dto';
import {SlotTransitionsDto} from '../model/slot-transitions-dto';
import {FavoriteRequest} from '../model/favorite-request';
import {ChallengeDto} from '../model/challenge-dto';
import {EmotionDto} from '../model/emotion-dto';
import {IntentDto} from '../model/intent-dto';
import {ContentEmotions} from '../model/content-emotions';
import {ContentTopics} from '../model/content-topics';
import {XpeditionScriptDto} from '../model/xpedition-script-dto';
import {XpeditionScriptStepDto} from '../model/xpedition-script-step-dto';
import {GroupBotDto} from '../model/group-bot-dto';
import {DialogueErrorListDto} from '../model/dialogue-error-list-dto';
import {ErrorFilter} from '../model/error-filter';
import {ErrorListRequest} from '../model/error-list-request';
import {RunAnalysisRequest} from '../model/run-analysis-request';
import {ProcedureDto} from '../model/procedure-dto';
import {ProcedureFilter} from '../model/procedure-filter';
import {ProcedureListDto} from '../model/procedure-list-dto';
import {ProcedureListRequest} from '../model/procedure-list-request';
import {UserListDto} from '../model/user-list-dto';
import {Statistic} from '../model/statistic';
import {StateDto} from '../model/state-dto';
import {BotTaskSettings} from '../model/bot-task-settings';
import {GroovyCompilerDto} from '../model/groovy-compiler-dto';
import {SessionListDto} from '../model/session-list-dto';
import {CategoryDto} from '../model/category-dto';
import {DeliveryDto} from '../model/delivery-dto';
import {ContentSetDto} from '../model/content-set-dto';
import {SetCompositionListDto} from '../model/set-composition-list-dto';
import {SetCompositionDto} from '../model/set-composition-dto';
import {JournalPageDto} from '../model/journal-page-dto';
import {UserJournalListDto} from '../model/user-journal-list-dto';
import {UserJournalDto} from '../model/user-journal-dto';
import {ContentMediaDto} from '../model/content-media-dto';
import {ImageType} from '../model/image-type.enum';
import {ImageSizeType} from '../model/image-size-type.enum';
import {DownloadResponse} from '../model/download-response';
import {UserContentDto} from '../model/user-content-dto';
import {PersonalityTraitsResponse} from '../model/personality-traits-response';
import {ExportResult} from '../model/export-result';
import {BotListDto} from '../model/bot-list-dto';
import {Language} from '../model/language';
import {TranslatedText} from '../model/translated-text';
import {ContentSetPartListDto} from '../model/content-set-part-list-dto';
import {CustomerDto} from '../model/customer-dto';
import {AgeDto} from '../model/age-dto';
import {ReadingDto} from '../model/reading-dto';
import {SchoolDashboard} from '../model/school-dashboard';
import {ProUserDto} from '../model/pro-user-dto';
import {TypeRoleDto} from '../model/type-role-dto';
import {CustomerListDto} from '../model/customer-list-dto';
import {UserMaterialsDto} from '../model/user-materials-dto';
import {ShareListDto} from '../model/share-list-dto';
import {RecipientsDto} from '../model/recipients-dto';
import {TypeShareDto} from '../model/type-share-dto';
import {DistrictDto} from '../model/district-dto';
import {SectionDto} from '../model/section-dto';
import {CleverUserDto} from '../model/clever-user-dto';
import {XpeditionDto} from '../model/xpedition-dto';
import {XpeditionListDto} from '../model/xpedition-list-dto';
import {XpeditionQuestionDto} from '../model/xpedition-question-dto';
import {XpeditionContentDto} from '../model/xpedition-content-dto';
import {QuestionAnswerDto} from '../model/question-answer-dto';
import {XpeditionsUserListDto} from '../model/xpeditions-user-list-dto';
import {SelfInterviewListDto} from '../model/self-interview-list-dto';
import {MediaFilter} from '../model/media-filter';
import {MediaListRequest} from '../model/media-list-request';
import {ContactListDto} from '../model/contact-list-dto';
import {UserInListDto} from '../model/user-in-list-dto';
import {SendingListDto} from '../model/sending-list-dto';
import {SendingDto} from '../model/sending-dto';
import {SendingContactsEventDto} from '../model/sending-contacts-event-dto';
import {SendingMetricsDto} from '../model/sending-metrics-dto';
import {ExchangeDto} from '../model/exchange-dto';
import {SendingClickedLinksDto} from '../model/sending-clicked-links-dto';
import {ContactUserDto} from '../model/contact-user-dto';
import {SuppressionListDto} from '../model/suppression-list-dto';
import {ExportContactsDto} from '../model/export-contacts-dto';
import {ContactUserCard} from '../model/contact-user-card';
import {UserMetadata} from '../model/user-metadata';
import {XpeditionsDashboardTable} from '../model/xpeditions-dashboard-table';
import {XpeditionRatingStatistics} from '../model/xpedition-rating-statistics';
import {XpeditionGoals} from '../model/xpedition-goals';
import {XpeditionRcStatistics} from '../model/xpedition-rc-statistics';
import {XpeditionLcStatistics} from '../model/xpedition-lc-statistics';
import {XpeditionsUserListRequest} from '../model/xpeditions-user-list-request';
import {StatisticsParameterDto} from '../model/statistics-parameter-dto';
import {BotStatisticsDto} from '../model/bot-statistics-dto';
import {StatisticsValueDto} from '../model/statistics-value-dto';
import {UpdateStatisticRequest} from '../model/update-statistic-request';
import {LabelDto} from '../model/label-dto';
import {CommentDto} from '../model/comment-dto';
import {ExportDialogueToHubspotRequest} from '../model/export-dialogue-to-hubspot-request';
import {DocumentStoreDto} from '../model/document-store-dto';
import {StorePartDto} from '../model/store-part-dto';
import {DocumentStoreListDto} from '../model/document-store-list-dto';
import {StorePartRequest} from '../model/store-part-request';
import {StoreStatusDto} from '../model/store-status-dto';
import {PdfExportRequest} from '../model/pdf-export-request';
import {LoadSettingsDto} from '../model/load-settings-dto';
import {RefreshStoreRequest} from '../model/refresh-store-request';
import {RefreshStoreResponse} from '../model/refresh-store-response';
import {SearchInStoreRequest} from '../model/search-in-store-request';
import {GenerateTextResponse} from '../model/generate-text-response';
import {EvaluateStoreRequest} from '../model/evaluate-store-request';
import {EvaluateStoreResponse} from '../model/evaluate-store-response';
import {StoreObj} from '../model/store-obj';
import {ExperimentListDto} from '../model/experiment-list-dto';
import {TestDatasetDto} from '../model/test-dataset-dto';
import {ExperimentDto} from '../model/experiment-dto';
import {ExperimentResultDto} from '../model/experiment-result-dto';
import {DatasetRowDto} from '../model/dataset-row-dto';
import {VectorStore, VectorStoreStatusResponse} from '../model/vector-store-status-response';
import {UpdateStatusRequest} from '../model/update-status-request';
import {GenerateTextContext} from '../model/generate-text-context';
import {GenerateTextRequest} from '../model/generate-text-request';
import {GetPdfInfoResponse} from '../model/get-pdf-info-response';
import {ReCreateResponse} from '../model/re-create-response';
import {ReCreateRequest} from '../model/re-create-request';
import {ReCheckResponse} from '../model/re-check-response';
import {ReCheckRequest} from '../model/re-check-request';
import {ExportWebRequest} from '../model/export-web-request';
import {ExportWebResponse} from '../model/export-web-response';
import {ParseSiteResponse} from '../model/parse-site-response';
import {AddFromContentsRequest} from '../model/add-from-contents-request';
import {ChartSerie} from '../model/chart-serie';
import {BarChartSerie} from '../model/bar-chart-serie';
import {NumberResponse} from '../model/number-response';
import {ArchiveProcedure} from '../model/archive-procedure.enum';
import {ArticleCategoryDto} from '../model/article-category-dto';
import {ArticleDto} from '../model/article-dto';
import {FilterArticleMode, FilterBoolean, FilterDlgStatus, FilterValueLangMode, FilterValueMode} from '../model/filter-value-mode.enum';
import {ArticleCollectionDto} from '../model/article-collection-dto';
import {XpeditionStStatistics} from '../model/xpedition-st-statistics';
import {LocationDto} from '../model/location-dto';
import {ArticleExchangeDto} from '../model/article-exchange-dto';
import {RaDialoguesDto} from '../model/ra-dialogues-dto';
import {ReviewDialogueListDto} from '../model/review-dialogue-list-dto';
import {RaGroupType} from '../model/ra-group-type.enum';
import {RaArticlesDto} from '../model/ra-articles-dto';
import {ConversationDashboardDto, StoreDashboardDto} from '../model/store-dashboard-dto';
import {OrganizationListDto} from '../model/organization-list-dto';
import {OrganizationDto} from '../model/organization-dto';
import {ServiceListDto} from '../model/service-list-dto';
import {ServiceDto} from '../model/service-dto';
import {DisorderDto} from '../model/disorder-dto';
import {TypeTreatmentsDto} from '../model/type-treatments-dto';
import {InsuranceDto} from '../model/insurance-dto';
import {CmCategoryDto} from '../model/cm-category-dto';
import {SubcategoryDto} from '../model/subcategory-dto';
import {CmLocationDto} from '../model/cm-location-dto';
import {CmLocationServiceDto} from '../model/cm-location-service-dto';
import {CmCollaboratorOrgDto} from '../model/cm-collaborator-org-dto';
import {CmContactPersonDto} from '../model/cm-contact-person-dto';
import {CmCollaboratorDto} from '../model/cm-collaborator-dto';
import {ServiceReportDto} from '../model/service-report-dto';
import {CmCountyDto} from '../model/cm-county-dto';
import {CMRegionDto} from '../model/cmregion-dto';
import {CmAgeDto} from '../model/cm-age-dto';
import {CmLanguageDto} from '../model/cm-language-dto';
import {ExerciseDto} from '../model/exercise-dto';
import {XpeditionExerciseListDto} from '../model/xpedition-exercise-list-dto';
import {CreateDialogueRequest} from '../model/create-dialogue-request';
import {ExerciseCreateDto} from '../model/exercise-create-dto';
import {ChangeOrderType} from '../model/change-order-type.enum';
import {CmServiceDashboardDto} from '../model/cm-service-dashboard-dto';
import {ServiceExchangeDto} from '../model/service-exchange-dto';
import {Injectable} from '@angular/core';
import {CrisisListDto} from '../model/crisis-list-dto';
import {UserGroupDto} from '../model/user-group-dto';
import {JournalListDto} from '../model/journal-list-dto';
import {QuestionnaireReportDto} from '../model/questionnaire-report-dto';

// import {Bot} from '../model/bot';
// import {Dialogue} from '../model/dialogue';
// import {BooleanResponse} from '../model/boolean-response';
// import {MessageShowType} from '../model/message-show-type.enum';
// import {Message} from '../model/message';
// import {MediaType} from '../model/media-type.enum';
// import {MediaSet} from '../model/media-set';
// import {Media} from '../model/media';
// import {Picture} from '../model/picture';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  baseUrl = environment.baseUrl;

  constructor(private httpClient: HttpClient) {
  }

  authorization(key: string, login: string, password: string): Observable<User> {
    return this.httpClient.post<User>(`${this.baseUrl}/authorization`, {key, login, password});
  }

  registration(key: string, user: User): Observable<User> {
    return this.httpClient.post<User>(`${this.baseUrl}/registration`, {key, user});
  }

  getBotList(): Observable<BotListDto[]> {
    return this.httpClient.get<BotListDto[]>(`${this.baseUrl}/bot/list`);
  }

  getBotSearchList(search: string, limit: number, offset: number, sortProp: string, sortDir: string): Observable<PagedData<BotListDto>> {
    return this.httpClient.get<PagedData<BotListDto>>(`${this.baseUrl}/bot/search/list?limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getBot(botId): Observable<Bot> {
    return this.httpClient.get<Bot>(`${this.baseUrl}/bot/` + botId);
  }

  getMainBot(): Observable<BotListDto> {
    return this.httpClient.get<BotListDto>(`${this.baseUrl}/bot/main`);
  }

  getBotDashboard(botId: number): Observable<BotDashboard> {
    return this.httpClient.get<BotDashboard>(`${this.baseUrl}/bot/dashboard/` + botId);
  }

  getSchoolDashboard(): Observable<SchoolDashboard> {
    return this.httpClient.get<SchoolDashboard>(`${this.baseUrl}/school/dashboard`);
  }

  updateBot(bot: Bot): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/bot/update`, bot);
  }

  getMediaFullList(search: string = null): Observable<Media[]> {
    return this.httpClient.get<Media[]>(`${this.baseUrl}/media/full/list` + (search ? (`?search=` + encodeURI(search)) : ''));
  }

  getMediaFormList(search: string = null): Observable<Media[]> {
    return this.httpClient.get<Media[]>(`${this.baseUrl}/media/form/list` + (search ? (`?search=` + encodeURI(search)) : ''));
  }

  getContentList(filter: ContentFilter, search: string, limit: number, offset: number, sortProp: string,
                 sortDir: string): Observable<PagedData<ContentListDto>> {
    return this.httpClient.post<PagedData<ContentListDto>>(`${this.baseUrl}/content/list`,
      new ContentListRequest(search, limit, offset, sortProp, sortDir, filter));
  }

  getContentFullList(search: string = null): Observable<ContentListDto[]> {
    return this.httpClient.get<ContentListDto[]>(`${this.baseUrl}/content/full/list` + (search ? (`?search=` + encodeURI(search)) : ''));
  }

  getContent(contentId): Observable<ContentDto> {
    return this.httpClient.get<ContentDto>(`${this.baseUrl}/content/` + contentId);
  }

  getContentByLang(contentId, lang): Observable<ContentDto> {
    return this.httpClient.get<ContentDto>(`${this.baseUrl}/content/` + contentId + `/` + lang);
  }

  getContentListById(contentId): Observable<ContentDto[]> {
    return this.httpClient.get<ContentDto[]>(`${this.baseUrl}/content/list/` + contentId);
  }

  createContent(content: ContentDto): Observable<ContentDto> {
    return this.httpClient.post<ContentDto>(`${this.baseUrl}/content/create`, content);
  }

  createContentLang(content: ContentDto, lang: string, translateToLang: boolean): Observable<ContentDto> {
    return this.httpClient.post<ContentDto>(`${this.baseUrl}/content/create/translated`, {
      content,
      lang,
      translateToLang
    });
  }

  translate(message: string, langFrom: string, langTo: string): Observable<TranslatedText> {
    return this.httpClient.post<TranslatedText>(`${this.baseUrl}/language/translate`, {message, langFrom, langTo});
  }

  updateContent(content: ContentDto): Observable<ContentDto> {
    return this.httpClient.post<ContentDto>(`${this.baseUrl}/content/update`, content);
  }

  deleteContent(contentId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/content/delete`, contentId);
  }

  updateAllUtterance(botId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/delivery/action/update/all`, botId);
  }

  getEmotionList(): Observable<EmotionDto[]> {
    return this.httpClient.get<EmotionDto[]>(`${this.baseUrl}/content/emotions`);
  }

  getTypeContentList(): Observable<TopicListDto[]> {
    return this.httpClient.get<TopicListDto[]>(`${this.baseUrl}/content/types`);
  }

  getTranslationsTypeContent(id: number): Observable<TopicListDto[]> {
    return this.httpClient.get<TopicListDto[]>(`${this.baseUrl}/topic/translations/` + id);
  }

  getChallengeList(): Observable<ChallengeDto[]> {
    return this.httpClient.get<ChallengeDto[]>(`${this.baseUrl}/content/challenges`);
  }

  getTranslationsChallenge(id: number): Observable<ChallengeDto[]> {
    return this.httpClient.get<ChallengeDto[]>(`${this.baseUrl}/challenge/translations/` + id);
  }

  getCategoryList(): Observable<CategoryDto[]> {
    return this.httpClient.get<CategoryDto[]>(`${this.baseUrl}/content/categories`);
  }

  getAgeListContent(): Observable<AgeDto[]> {
    return this.httpClient.get<AgeDto[]>(`${this.baseUrl}/content/ages`);
  }

  getTranslationsAge(id: number): Observable<AgeDto[]> {
    return this.httpClient.get<AgeDto[]>(`${this.baseUrl}/age/translations/` + id);
  }

  getReadingListContent(): Observable<ReadingDto[]> {
    return this.httpClient.get<ReadingDto[]>(`${this.baseUrl}/content/reading`);
  }

  getTranslationsReading(id: number): Observable<ReadingDto[]> {
    return this.httpClient.get<ReadingDto[]>(`${this.baseUrl}/reading/translations/` + id);
  }

  getQuestionnairesList(botId: number, search: string, limit: number, offset: number,
                        sortProp: string, sortDir: string): Observable<PagedData<QuestionnairesListDto>> {
    return this.httpClient.get<PagedData<QuestionnairesListDto>>(`${this.baseUrl}/slotform/list?botId=` + botId +
      `&limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getAllSlotFillingFormList(): Observable<QuestionnairesListDto[]> {
    return this.httpClient.get<QuestionnairesListDto[]>(`${this.baseUrl}/slotform/list/all`);
  }

  getAllSlotList(sffId: number): Observable<SlotListDto[]> {
    return this.httpClient.get<SlotListDto[]>(`${this.baseUrl}/slot/list/all/` + sffId);
  }

  getDialogueList(botId: number, search: string, limit: number, offset: number,
                  sortProp: string, sortDir: string): Observable<PagedData<DialogueListDto>> {
    return this.httpClient.get<PagedData<DialogueListDto>>(`${this.baseUrl}/dialogue/kb/list?botId=` + botId +
      `&limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getConversationList(search: string, dateB: string, dateE: string, limit: number, offset: number,
                      sortProp: string, sortDir: string, labels: string[], hasEmotions: boolean, hasChallenges: boolean,
                      hasComments: boolean, msgCountFrom: string, msgCountTo: string, sessionsCountFrom: string,
                      sessionsCountTo: string, userGroupId: number): Observable<PagedData<ConversationListDto>> {
    return this.httpClient.get<PagedData<ConversationListDto>>(`${this.baseUrl}/dialogue/conversation/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : '') + (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : '') +
      (labels && labels.length > 0 ? (`&labels=` + encodeURI(labels.join(','))) : '') +
      (hasEmotions ? (`&hasEmotions=` + hasEmotions) : '') + (hasChallenges ? (`&hasChallenges=` + hasChallenges) : '') +
      (hasComments ? (`&hasComments=` + hasComments) : '') +
      (msgCountFrom && msgCountFrom.length > 0 ? (`&msgCountFrom=` + msgCountFrom) : '') +
      (msgCountTo && msgCountTo.length > 0 ? (`&msgCountTo=` + msgCountTo) : '') +
      (sessionsCountFrom && sessionsCountFrom.length > 0 ? (`&sessionsCountFrom=` + sessionsCountFrom) : '') +
      (sessionsCountTo && sessionsCountTo.length > 0 ? (`&sessionsCountTo=` + sessionsCountTo) : '') +
      (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  exportDialoguesToZip(search: string, dateB: string, dateE: string, limit: number, offset: number,
                       sortProp: string, sortDir: string, labels: string[], hasEmotions: boolean, hasChallenges: boolean,
                       hasComments: boolean, msgCountFrom: string, msgCountTo: string, sessionsCountFrom: string,
                       sessionsCountTo: string, userGroupId: number): Observable<ExportResult> {
    return this.httpClient.get<ExportResult>(`${this.baseUrl}/dialogue/conversation/list/export?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : '') + (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : '') +
      (labels && labels.length > 0 ? (`&labels=` + encodeURI(labels.join(','))) : '') +
      (hasEmotions ? (`&hasEmotions=` + hasEmotions) : '') + (hasChallenges ? (`&hasChallenges=` + hasChallenges) : '') +
      (hasComments ? (`&hasComments=` + hasComments) : '') +
      (msgCountFrom && msgCountFrom.length > 0 ? (`&msgCountFrom=` + msgCountFrom) : '') +
      (msgCountTo && msgCountTo.length > 0 ? (`&msgCountTo=` + msgCountTo) : '') +
      (sessionsCountFrom && sessionsCountFrom.length > 0 ? (`&sessionsCountFrom=` + sessionsCountFrom) : '') +
      (sessionsCountTo && sessionsCountTo.length > 0 ? (`&sessionsCountTo=` + sessionsCountTo) : '') +
      (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  exportConversationListToXls(dialodId: number): Observable<ExportResult> {
    return this.httpClient.get<ExportResult>(`${this.baseUrl}/dialogue/conversation/export/${dialodId}`);
  }

  getDialogueChallengeList(id: number, dateB: string, dateE: string, search: string, limit: number, offset: number,
                           sortProp: string, sortDir: string, userGroupId: number): Observable<PagedData<ConversationListDto>> {
    return this.httpClient.get<PagedData<ConversationListDto>>(`${this.baseUrl}/dialogue/conversation/list/challenges?id=`
      + id + `&limit=` + limit + `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : '') + (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : '') + (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  getDialogueEmotionList(id: number, dateB: string, dateE: string, search: string, limit: number, offset: number,
                         sortProp: string, sortDir: string, userGroupId: number): Observable<PagedData<ConversationListDto>> {
    return this.httpClient.get<PagedData<ConversationListDto>>(`${this.baseUrl}/dialogue/conversation/list/emotions?id=`
      + id + `&limit=` + limit + `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : '') + (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : '') + (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  getDialogueQRList(id: number, dateB: string, dateE: string, search: string, limit: number, offset: number,
                    sortProp: string, sortDir: string, userGroupId: number): Observable<PagedData<ConversationListDto>> {
    return this.httpClient.get<PagedData<ConversationListDto>>(`${this.baseUrl}/dialogue/conversation/list/qr?id=`
      + id + `&limit=` + limit + `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : '') + (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : '') + (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  getDialogueUserList(id: number, dateB: string, dateE: string, search: string, limit: number, offset: number,
                      sortProp: string, sortDir: string, userGroupId: number): Observable<PagedData<ConversationListDto>> {
    return this.httpClient.get<PagedData<ConversationListDto>>(`${this.baseUrl}/dialogue/conversation/list/users?id=`
      + id + `&limit=` + limit + `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : '') + (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : '') + (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  getFavoriteList(auth0Id: string, search: string, limit: number, offset: number,
                  sortProp: string, sortDir: string, userGroupId: number): Observable<PagedData<ConversationListDto>> {
    return this.httpClient.get<PagedData<ConversationListDto>>(`${this.baseUrl}/dialogue/conversation/list/favorite?auth0Id=`
      + encodeURI(auth0Id) + `&type=1` + `&limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : '') + (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  getRecentlyList(auth0Id: string, search: string, limit: number, offset: number,
                  sortProp: string, sortDir: string, userGroupId: number): Observable<PagedData<ConversationListDto>> {
    return this.httpClient.get<PagedData<ConversationListDto>>(`${this.baseUrl}/dialogue/conversation/list/favorite?auth0Id=`
      + encodeURI(auth0Id) + `&type=0` + `&limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : '') + (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  getDialogue(id: number): Observable<Dialogue> {
    return this.httpClient.get<Dialogue>(`${this.baseUrl}/dialogue/` + id);
  }

  getHistory(dialogId: number, type: MessageShowType, offset: number, limit: number): Observable<Message[]> {
    const url = `${this.baseUrl}/message/${dialogId}?type=${MessageShowType[type]}&offset=${offset}&limit=${limit}`;
    return this.httpClient.get<Message[]>(url);
  }

  getEventList(dialogId: number, botId: number, dateB: string, dateE: string, search: string, limit: number, offset: number,
               sortProp: string, sortDir: string, userId: number): Observable<PagedData<EventListDto>> {
    return this.httpClient.get<PagedData<EventListDto>>(`${this.baseUrl}/event/list?dialogId=` + dialogId +
      `&botId=` + botId +
      `&userId=` + userId +
      `&limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : '') +
      (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : ''));
  }

  getSessionList(dialogId: number, search: string, limit: number, offset: number,
                 sortProp: string, sortDir: string): Observable<PagedData<SessionListDto>> {
    return this.httpClient.get<PagedData<SessionListDto>>(`${this.baseUrl}/event/sessions?dialogId=` + dialogId +
      `&limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getUserContentList(userId: number, search: string, limit: number, offset: number,
                     sortProp: string, sortDir: string): Observable<PagedData<UserContentDto>> {
    return this.httpClient.get<PagedData<UserContentDto>>(`${this.baseUrl}/content/user/list?userId=` + userId +
      `&limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getStorage(actionEventId: number): Observable<StringResponse> {
    return this.httpClient.get<StringResponse>(`${this.baseUrl}/event/storage/` + actionEventId);
  }

  deleteMessages(messageId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/message/delete`, messageId);
  }

  getUserDialogueState(dialogId: number, botId: number, userId: number): Observable<StateDto[]> {
    return this.httpClient.get<StateDto[]>(`${this.baseUrl}/event/user/` + dialogId + `/` + botId + `/` + userId);
  }

  getSelfInterviewState(actionEventId: number): Observable<StateDto[]> {
    return this.httpClient.get<StateDto[]>(`${this.baseUrl}/event/selfinterview/` + actionEventId);
  }

  getTopicList(search: string, limit: number, offset: number,
               sortProp: string, sortDir: string): Observable<PagedData<TopicListDto>> {
    return this.httpClient.get<PagedData<TopicListDto>>(`${this.baseUrl}/topic/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getAgeList(search: string, limit: number, offset: number,
             sortProp: string, sortDir: string): Observable<PagedData<AgeDto>> {
    return this.httpClient.get<PagedData<AgeDto>>(`${this.baseUrl}/age/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getReadingList(search: string, limit: number, offset: number,
                 sortProp: string, sortDir: string): Observable<PagedData<ReadingDto>> {
    return this.httpClient.get<PagedData<ReadingDto>>(`${this.baseUrl}/reading/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  uploadPictureToServer(fileBody: string, fileName: string): Observable<StringResponse> {
    const type = ImageType.FILE_SERVER;
    return this.httpClient.post<StringResponse>(`${this.baseUrl}/image/upload/server`, {
      undefined,
      type,
      fileBody,
      fileName
    });
  }

  uploadPicture(type: ImageType, fileBody: string, fileName: string, imageId: number): Observable<Picture> {
    return this.httpClient.post<Picture>(`${this.baseUrl}/image/upload`, {
      undefined,
      type,
      fileBody,
      fileName,
      imageId
    });
  }

  downloadPicture(fileId: number, size: ImageSizeType): Observable<DownloadResponse> {
    return this.httpClient.get<DownloadResponse>(`${this.baseUrl}/image/download/${fileId}/${size}`);
  }

  getActionList(agId: number, botId: number, search: string, limit: number, offset: number,
                sortProp: string, sortDir: string): Observable<PagedData<ActionListDto>> {
    return this.httpClient.get<PagedData<ActionListDto>>(`${this.baseUrl}/action/list?botId=` + botId + `&agId=` + agId +
      `&limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }


  getActionFormList(sffId: number, search: string, limit: number, offset: number,
                    sortProp: string, sortDir: string): Observable<PagedData<ActionListDto>> {
    return this.httpClient.get<PagedData<ActionListDto>>(`${this.baseUrl}/action/form/list?sffId=` + sffId +
      `&limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getActionTypes(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/action/types`);
  }

  getActionGroups(): Observable<ActionGroupDto[]> {
    return this.httpClient.get<ActionGroupDto[]>(`${this.baseUrl}/action-group/root/list`);
  }

  getAction(actionId): Observable<ActionDto> {
    return this.httpClient.get<ActionDto>(`${this.baseUrl}/action/` + actionId);
  }

  createAction(action: ActionDto, botId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/action/create`, {action, botId});
  }

  updateAction(action: ActionDto): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/action/update`, action);
  }

  copyAction(action: ActionDto, botId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/action/copy`, {action, botId});
  }

  deleteAction(actionId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/action/delete`, actionId);
  }


  getUtteranceList(actionId: number, botId: number, search: string, limit: number, offset: number,
                   sortProp: string, sortDir: string): Observable<PagedData<UtteranceDto>> {
    return this.httpClient.get<PagedData<UtteranceDto>>(`${this.baseUrl}/utterance/all?botId=` + botId + `&actionId=` + actionId +
      `&limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getUtterance(utteranceId): Observable<UtteranceDto> {
    return this.httpClient.get<UtteranceDto>(`${this.baseUrl}/utterance/` + utteranceId);
  }

  createUtterance(utterance: UtteranceDto): Observable<UtteranceDto> {
    return this.httpClient.post<UtteranceDto>(`${this.baseUrl}/utterance/create`, utterance);
  }

  updateUtterance(utterance: UtteranceDto): Observable<UtteranceDto> {
    return this.httpClient.post<UtteranceDto>(`${this.baseUrl}/utterance/update`, utterance);
  }

  deleteUtterance(utterance: UtteranceDto): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/utterance/delete`, utterance);
  }

  getActionConfidenceList(actionId: number): Observable<ActionConfidenceDto[]> {
    return this.httpClient.get<ActionConfidenceDto[]>(`${this.baseUrl}/ac/list/` + actionId);
  }

  getActionConfidence(acId): Observable<ActionConfidenceDto> {
    return this.httpClient.get<ActionConfidenceDto>(`${this.baseUrl}/ac/` + acId);
  }

  createActionConfidence(actionConfidence: ActionConfidenceDto): Observable<ActionConfidenceDto> {
    return this.httpClient.post<ActionConfidenceDto>(`${this.baseUrl}/ac/create`, actionConfidence);
  }

  updateActionConfidence(actionConfidence: ActionConfidenceDto): Observable<ActionConfidenceDto> {
    return this.httpClient.post<ActionConfidenceDto>(`${this.baseUrl}/ac/update`, actionConfidence);
  }

  deleteActionConfidence(actionConfidence: ActionConfidenceDto): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/ac/delete`, actionConfidence);
  }

  getSlotFillingForm(sffId: number): Observable<SlotFilingFormDto> {
    return this.httpClient.get<SlotFilingFormDto>(`${this.baseUrl}/slotform/` + sffId);
  }

  createSlotFillingForm(slotFilingFormDto: SlotFilingFormDto): Observable<SlotFilingFormDto> {
    return this.httpClient.post<SlotFilingFormDto>(`${this.baseUrl}/slotform/create`, slotFilingFormDto);
  }

  updateSlotFillingForm(slotFilingFormDto: SlotFilingFormDto): Observable<SlotFilingFormDto> {
    return this.httpClient.post<SlotFilingFormDto>(`${this.baseUrl}/slotform/update`, slotFilingFormDto);
  }

  exportForm(slotFormClearRequest: SlotFormClearRequest): Observable<FileDto> {
    return this.httpClient.post<FileDto>(`${this.baseUrl}/slotform/export/yaml`, slotFormClearRequest);
  }

  exportAction(actionId: number): Observable<FileDto> {
    return this.httpClient.post<FileDto>(`${this.baseUrl}/action/export/yaml`, actionId);
  }

  deleteSlotFillingForm(slotFormClearRequest: SlotFormClearRequest): Observable<SlotFormClearRequest> {
    return this.httpClient.post<SlotFormClearRequest>(`${this.baseUrl}/slotform/delete`, slotFormClearRequest);
  }

  trainForm(sffId: number): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrl}/slotform/train/` + sffId);
  }

  applyToKB(id: number, customerId: number): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrl}/content/self-interview/all/` + id + `/` + customerId);
  }

  applyToKBPartly(id: number, customerId: number): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrl}/content/self-interview/partly/` + id + `/` + customerId);
  }

  updateUtteranceOfAction(deliveryId: number): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrl}/delivery/action/update/` + deliveryId);
  }

  addUtteranceOfAction(deliveryId: number): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrl}/delivery/action/add/` + deliveryId);
  }

  getManagementSummaryList(sffId: number): Observable<ManagementSummaryDto[]> {
    return this.httpClient.get<ManagementSummaryDto[]>(`${this.baseUrl}/manage-sum/list/` + sffId);
  }

  getManagementSummary(id): Observable<ManagementSummaryDto> {
    return this.httpClient.get<ManagementSummaryDto>(`${this.baseUrl}/manage-sum/` + id);
  }

  createManagementSummary(managementSummaryDto: ManagementSummaryDto): Observable<ManagementSummaryDto> {
    return this.httpClient.post<ManagementSummaryDto>(`${this.baseUrl}/manage-sum/create`, managementSummaryDto);
  }

  updateManagementSummary(managementSummaryDto: ManagementSummaryDto): Observable<ManagementSummaryDto> {
    return this.httpClient.post<ManagementSummaryDto>(`${this.baseUrl}/manage-sum/update`, managementSummaryDto);
  }

  deleteManagementSummary(managementSummaryDto: ManagementSummaryDto): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/manage-sum/delete`, managementSummaryDto);
  }

  getSlotList(sffId: number, search: string, limit: number, offset: number,
              sortProp: string, sortDir: string): Observable<PagedData<SlotListDto>> {
    return this.httpClient.get<PagedData<SlotListDto>>(`${this.baseUrl}/slot/list?sffId=` + sffId +
      `&limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getSlot(id): Observable<SlotDto> {
    return this.httpClient.get<SlotDto>(`${this.baseUrl}/slot/` + id);
  }

  createSlot(slotDto: SlotDto): Observable<SlotDto> {
    return this.httpClient.post<SlotDto>(`${this.baseUrl}/slot/create`, slotDto);
  }

  updateSlot(slotDto: SlotDto): Observable<SlotDto> {
    return this.httpClient.post<SlotDto>(`${this.baseUrl}/slot/update`, slotDto);
  }

  deleteSlot(slotId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/slot/delete`, slotId);
  }

  getTypeParameterList(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/parameter/types`);
  }

  getParameterList(botId: number, search: string, limit: number, offset: number,
                   sortProp: string, sortDir: string): Observable<PagedData<ParameterDto>> {
    return this.httpClient.get<PagedData<ParameterDto>>(`${this.baseUrl}/parameter/list?limit=` + limit + `&offset=` + offset
      + (botId ? (`&botId=` + botId) : '') + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '')
      + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getAllParameterList(botId: number): Observable<ParameterDto[]> {
    return this.httpClient.get<ParameterDto[]>(`${this.baseUrl}/parameter/list/all/` + botId);
  }

  getParameter(id): Observable<ParameterDto> {
    return this.httpClient.get<ParameterDto>(`${this.baseUrl}/parameter/` + id);
  }

  createParameter(parameterDto: ParameterDto): Observable<ParameterDto> {
    return this.httpClient.post<ParameterDto>(`${this.baseUrl}/parameter/create`, parameterDto);
  }

  updateParameter(parameterDto: ParameterDto): Observable<ParameterDto> {
    return this.httpClient.post<ParameterDto>(`${this.baseUrl}/parameter/update`, parameterDto);
  }

  deleteParameter(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/parameter/delete`, id);
  }

  getAllowParameterValueList(parameterId: number): Observable<AllowParameterValueDto[]> {
    return this.httpClient.get<AllowParameterValueDto[]>(`${this.baseUrl}/apv/list/` + parameterId);
  }

  getAllowParameterValue(id): Observable<AllowParameterValueDto> {
    return this.httpClient.get<AllowParameterValueDto>(`${this.baseUrl}/apv/` + id);
  }

  createAllowParameterValue(allowParameterValueDto: AllowParameterValueDto): Observable<AllowParameterValueDto> {
    return this.httpClient.post<AllowParameterValueDto>(`${this.baseUrl}/apv/create`, allowParameterValueDto);
  }

  updateAllowParameterValue(allowParameterValueDto: AllowParameterValueDto): Observable<AllowParameterValueDto> {
    return this.httpClient.post<AllowParameterValueDto>(`${this.baseUrl}/apv/update`, allowParameterValueDto);
  }

  deleteAllowParameterValue(allowParameterValueDto: AllowParameterValueDto): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/apv/delete`, allowParameterValueDto);
  }

  getUserList(hasBlocked: FilterBoolean, search: string, limit: number, offset: number, sortProp: string, sortDir: string,
              userGroupId: number): Observable<PagedData<UserListDto>> {
    return this.httpClient.get<PagedData<UserListDto>>(`${this.baseUrl}/user/list?limit=` + limit + `&offset=` + offset +
      (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : '') +
      (hasBlocked ? `&hasBlocked=${hasBlocked}` : '') + (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  getUsers(search: string = null): Observable<UserListDto[]> {
    return this.httpClient.get<UserListDto[]>(`${this.baseUrl}/user/search` + (search ? (`?search=` + encodeURI(search)) : ''));
  }

  getProUserList(search: string, limit: number, offset: number, sortProp: string, sortDir: string): Observable<PagedData<ProUserDto>> {
    return this.httpClient.get<PagedData<ProUserDto>>(`${this.baseUrl}/school/pro/list?&limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getDistrictList(search: string, limit: number, offset: number, sortProp: string, sortDir: string): Observable<PagedData<DistrictDto>> {
    return this.httpClient.get<PagedData<DistrictDto>>(`${this.baseUrl}/school/district/list?&limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getSectionList(teacherId: number, search: string, limit: number, offset: number, sortProp: string, sortDir: string):
    Observable<PagedData<SectionDto>> {
    return this.httpClient.get<PagedData<SectionDto>>(`${this.baseUrl}/school/teacher/sections/list?teacherId=`
      + teacherId + `&limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getTeacherStudentList(teacherId: number, search: string, limit: number, offset: number, sortProp: string, sortDir: string):
    Observable<PagedData<CleverUserDto>> {
    return this.httpClient.get<PagedData<CleverUserDto>>(`${this.baseUrl}/school/teacher/students/list?teacherId=`
      + teacherId + `&limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getSectionStudentList(sectionId: number, search: string, limit: number, offset: number, sortProp: string, sortDir: string):
    Observable<PagedData<CleverUserDto>> {
    return this.httpClient.get<PagedData<CleverUserDto>>(`${this.baseUrl}/school/section/students/list?sectionId=`
      + sectionId + `&limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getDistrictStudentList(districtId: number, search: string, limit: number, offset: number, sortProp: string, sortDir: string):
    Observable<PagedData<CleverUserDto>> {
    return this.httpClient.get<PagedData<CleverUserDto>>(`${this.baseUrl}/school/district/students/list?districtId=`
      + districtId + `&limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getDistrictTeacherList(districtId: number, search: string, limit: number, offset: number, sortProp: string, sortDir: string):
    Observable<PagedData<CleverUserDto>> {
    return this.httpClient.get<PagedData<CleverUserDto>>(`${this.baseUrl}/school/district/teachers/list?districtId=`
      + districtId + `&limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getUser(id): Observable<UserDto> {
    return this.httpClient.get<UserDto>(`${this.baseUrl}/user/` + id);
  }

  getAdminUserList(customerId: number, search: string, limit: number, offset: number, sortProp: string, sortDir: string)
    : Observable<PagedData<User>> {
    return this.httpClient.get<PagedData<User>>(`${this.baseUrl}/admin/user/list?&limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : '')
      + (customerId ? (`&customerId=` + customerId) : ''));
  }

  getRoleAdminUserList(trId: number, search: string, limit: number, offset: number, sortProp: string, sortDir: string)
    : Observable<PagedData<User>> {
    return this.httpClient.get<PagedData<User>>(`${this.baseUrl}/admin/user/role/list/` + trId + `?&limit=` + limit
      + `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '')
      + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getRoleBotUserList(trId: number, search: string, limit: number, offset: number, sortProp: string, sortDir: string)
    : Observable<PagedData<User>> {
    return this.httpClient.get<PagedData<User>>(`${this.baseUrl}/user/users/role/list/` + trId + `?&limit=` + limit
      + `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '')
      + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getAdminUser(id): Observable<User> {
    return this.httpClient.get<User>(`${this.baseUrl}/admin/user/` + id);
  }

  getAdminUserByEmail(email): Observable<User> {
    return this.httpClient.get<User>(`${this.baseUrl}/admin/user/email/` + email);
  }

  getAdminUserCurrent(): Observable<User> {
    return this.httpClient.get<User>(`${this.baseUrl}/admin/current`);
  }

  createAdminUser(user: User): Observable<User> {
    return this.httpClient.post<User>(`${this.baseUrl}/admin/user/create`, user);
  }

  updateAdminUser(user: User): Observable<User> {
    return this.httpClient.post<User>(`${this.baseUrl}/admin/user/update`, user);
  }

  deleteAdminUser(user: User): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/admin/user/delete`, user.id);
  }

  getTypeRoleList(): Observable<TypeRoleDto[]> {
    return this.httpClient.get<TypeRoleDto[]>(`${this.baseUrl}/admin/type/roles`);
  }

  getUserTypeRoleList(): Observable<TypeRoleDto[]> {
    return this.httpClient.get<TypeRoleDto[]>(`${this.baseUrl}/user/type/roles`);
  }

  getUserRoleList(userId: number): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/user/role/list/` + userId);
  }

  getAdminUserRoleList(auId: number): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/admin/role/list/` + auId);
  }

  getUserRoleListByAuth0Id(id): Observable<string[]> {
    return this.httpClient.post<string[]>(`${this.baseUrl}/admin/role/list`, {id});
  }

  exportUserRolesFromAuth0(auId): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/admin/role/user/auth0/export`, auId);
  }

  importUserRolesToAuth0(auId): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/admin/role/user/auth0/import`, auId);
  }

  clearRoles(auId): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/admin/roles/clear`, auId);
  }

  clearBotUserRoles(userId): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/user/roles/clear`, userId);
  }

  createAdminUserRole(auIds: number[], roleIds: number[]): Observable<User> {
    return this.httpClient.post<User>(`${this.baseUrl}/admin/role/create`, {auIds, roleIds});
  }

  createBotUserRole(userIds: number[], roleIds: number[]): Observable<UserDto> {
    return this.httpClient.post<UserDto>(`${this.baseUrl}/user/role/create`, {userIds, roleIds});
  }

  deleteAdminUserRole(auIds: number[], roleIds: number[]): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/admin/role/delete`, {auIds, roleIds});
  }

  deleteBotUserRole(userIds: number[], roleIds: number[]): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/user/role/delete`, {userIds, roleIds});
  }

  getMediaList(filter: MediaFilter, search: string, limit: number, offset: number, sortProp: string, sortDir: string):
    Observable<PagedData<MediaDto>> {
    return this.httpClient.post<PagedData<MediaDto>>(`${this.baseUrl}/media/list`,
      new MediaListRequest(filter, search, limit, offset, sortProp, sortDir));
  }

  getMedia(id): Observable<MediaDto> {
    return this.httpClient.get<MediaDto>(`${this.baseUrl}/media/` + id);
  }

  getMediaByType(name): Observable<MediaSetDto> {
    return this.httpClient.get<MediaSetDto>(`${this.baseUrl}/media-set/type/` + name);
  }

  createMedia(mediaDto: MediaDto): Observable<MediaDto> {
    return this.httpClient.post<MediaDto>(`${this.baseUrl}/media/create`, mediaDto);
  }

  updateMedia(mediaDto: MediaDto): Observable<MediaDto> {
    return this.httpClient.post<MediaDto>(`${this.baseUrl}/media/update`, mediaDto);
  }

  deleteMedia(mediaDto: MediaDto): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/media/delete`, mediaDto);
  }

  getMediaSetFullList(): Observable<MediaSetDto[]> {
    return this.httpClient.get<MediaSetDto[]>(`${this.baseUrl}/media-set/full/list`);
  }

  getMediaSetList(search: string, limit: number, offset: number, sortProp: string, sortDir: string): Observable<PagedData<MediaSetDto>> {
    return this.httpClient.get<PagedData<MediaSetDto>>(`${this.baseUrl}/media-set/list?&limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getMediaSet(id): Observable<MediaSetDto> {
    return this.httpClient.get<MediaSetDto>(`${this.baseUrl}/media-set/` + id);
  }

  createMediaSet(mediaSetDto: MediaSetDto): Observable<MediaSetDto> {
    return this.httpClient.post<MediaSetDto>(`${this.baseUrl}/media-set/create`, mediaSetDto);
  }

  updateMediaSet(mediaSetDto: MediaSetDto): Observable<MediaSetDto> {
    return this.httpClient.post<MediaSetDto>(`${this.baseUrl}/media-set/update`, mediaSetDto);
  }

  deleteMediaSet(mediaSetDto: MediaSetDto): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/media-set/delete`, mediaSetDto);
  }

  getTypeMediaList(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/media-set/types`);
  }

  createActionGroup(group: ActionGroupDto): Observable<ActionGroupDto> {
    return this.httpClient.post<ActionGroupDto>(`${this.baseUrl}/action-group/create`, group);
  }

  updateActionGroup(group: ActionGroupDto): Observable<ActionGroupDto> {
    return this.httpClient.post<ActionGroupDto>(`${this.baseUrl}/action-group/update`, group);
  }

  deleteActionGroup(group: ActionGroupDto): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/action-group/delete`, group);
  }

  getGraphMessageData(period: string, userGroupId: number): Observable<ChartSerie[]> {
    return this.httpClient.get<ChartSerie[]>(`${this.baseUrl}/graph/messages?period=` + period +
      (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  getGraphDialoguesData(selectedDate: string): Observable<BarChartSerie[]> {
    return this.httpClient.get<BarChartSerie[]>(`${this.baseUrl}/graph/dialogues?date=` + selectedDate);
  }

  getGraphXpeditionsByDays(userGroupId: number): Observable<GraphModel> {
    return this.httpClient.get<GraphModel>(`${this.baseUrl}/graph/xpedition/dates` +
      (userGroupId ? (`?userGroupId=` + userGroupId) : ''));
  }

  getGraphXpeditionsCount(dateB: string, dateE: string, userGroupId: number): Observable<GraphModel> {
    return this.httpClient.get<GraphModel>(`${this.baseUrl}/graph/xpedition/count` +
      (dateB ? (`?dateB=` + encodeURI(dateB)) : '') +
      (dateE ? ((dateB ? `&` : `?`) + `dateE=` + encodeURI(dateE)) : '') +
      (userGroupId ? ((dateB || dateE ? `&` : `?`) + `userGroupId=` + userGroupId) : ''));
  }

  getXpeditionDashboardTable(dateB: string, dateE: string, userGroupId: number): Observable<XpeditionsDashboardTable[]> {
    return this.httpClient.get<XpeditionsDashboardTable[]>(`${this.baseUrl}/xpedition/dashboard/table` +
      (dateB ? (`?dateB=` + encodeURI(dateB)) : '') +
      (dateE ? ((dateB ? `&` : `?`) + `dateE=` + encodeURI(dateE)) : '') +
      (userGroupId ? ((dateB || dateE ? `&` : `?`) + `userGroupId=` + userGroupId) : ''));
  }

  getXpeditionStatistics(id: number, lang: string, type: string, userGroupId: number): Observable<XpeditionRatingStatistics[]> {
    return this.httpClient.get<XpeditionRatingStatistics[]>(`${this.baseUrl}/xpedition/statistics/rating/${id}/${lang}/${type}` +
      (userGroupId ? (`?userGroupId=` + userGroupId) : ''));
  }

  getXpeditionGoalStatistics(id: number, userGroupId: number): Observable<XpeditionGoals[]> {
    return this.httpClient.get<XpeditionGoals[]>(`${this.baseUrl}/xpedition/statistics/goal/${id}` +
      (userGroupId ? (`?userGroupId=` + userGroupId) : ''));
  }

  getXpeditionRcStatistics(id: number, userGroupId: number): Observable<XpeditionRcStatistics[]> {
    return this.httpClient.get<XpeditionRcStatistics[]>(`${this.baseUrl}/xpedition/statistics/rc/${id}` +
      (userGroupId ? (`?userGroupId=` + userGroupId) : ''));
  }

  getXpeditionLcStatistics(id: number, userGroupId: number): Observable<XpeditionLcStatistics[]> {
    return this.httpClient.get<XpeditionLcStatistics[]>(`${this.baseUrl}/xpedition/statistics/lc/${id}` +
      (userGroupId ? (`?userGroupId=` + userGroupId) : ''));
  }

  getXpeditionStStatistics(id: number, code: string, date: string, userGroupId: number): Observable<XpeditionStStatistics[]> {
    return this.httpClient.get<XpeditionStStatistics[]>(`${this.baseUrl}/xpedition/statistics/st/${id}/${code}?date=${date}` +
      (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  getXpeditionStSympomsStatistics(id: number, code: string, date: string, userGroupId: number): Observable<XpeditionStStatistics[]> {
    return this.httpClient.get<XpeditionStStatistics[]>(`${this.baseUrl}/xpedition/statistics/st/symptoms/${id}/${code}?date=${date}` +
      (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  getXpeditionStSelStatistics(id: number, code: string, category: string, date: string, userGroupId: number):
    Observable<XpeditionStStatistics[]> {
    return this.httpClient.get<XpeditionStStatistics[]>(`${this.baseUrl}/xpedition/statistics/st/${id}/${code}/${category}?date=${date}` +
      (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  getXpeditionStStatisticsAll(id: number, date: string, userGroupId: number): Observable<XpeditionStStatistics[]> {
    return this.httpClient.get<XpeditionStStatistics[]>(`${this.baseUrl}/xpedition/st/dialogues/${id}?date=${date}` +
      (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  getXpeditionStStatisticsUser(id: number, code: string, userId: number, date: string, category: string, groupBySymptoms?: boolean):
    Observable<XpeditionStStatistics[]> {
    return this.httpClient.get<XpeditionStStatistics[]>(`${this.baseUrl}/xpedition/st/statistics/${id}/${code}/${userId}` +
      (date ? (`?date=` + date) : '') + (groupBySymptoms === true || groupBySymptoms === false ? ((date ? `&` : `?`) +
        `groupBySymptoms=` + groupBySymptoms) : '') +
      (category ? ((date || groupBySymptoms === true || groupBySymptoms === false ? `&` : `?`) + `category=` + category) : ''));
  }

  updateXpeditionLcStatistics(days: number): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrl}/xpedition/statistics/update/${days}`);
  }

  publishBot(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/bot/publish`, id);
  }

  unPublishBot(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/bot/unpublish`, id);
  }

  deleteBot(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/bot/delete`, id);
  }

  getTypeAlerts(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/bot/type/alerts`);
  }

  saveAsBot(id: number): Observable<any> {
    // todo: call service
    return of(true);
  }

  clearKb(id: number): Observable<any> {
    // todo: call service
    return of(true);
  }

  copyKb(id: number): Observable<any> {
    // todo: call service
    return of(true);
  }

  exportKb(id: number): Observable<FileDto> {
    return this.httpClient.get<FileDto>(`${this.baseUrl}/bot/kb/export/yaml/` + id);
  }

  importKb(botId: number, fileBody: string, fileName: string): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/bot/kb/import/yaml`, {botId, fileBody, fileName});
  }

  exportXpedition(id: number): Observable<FileDto> {
    return this.httpClient.get<FileDto>(`${this.baseUrl}/xpedition/export/yaml/` + id);
  }

  importXpedition(id: number, fileBody: string, fileName: string): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/xpedition/import/yaml`, {id, fileBody, fileName});
  }

  translateXpedition(id: number, language: string): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/xpedition/translate/xpedition`, {id, language});
  }

  translateContent(id: number, language: string): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/xpedition/translate/content`, {id, language});
  }

  getConditionsList(botId: number, search: string, limit: number, offset: number,
                    sortProp: string, sortDir: string): Observable<PagedData<VActionConfidenceDto>> {
    return this.httpClient.get<PagedData<VActionConfidenceDto>>(`${this.baseUrl}/ac/all?botId=` + botId +
      `&limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getUtterancesList(botId: number, search: string, limit: number, offset: number,
                    sortProp: string, sortDir: string): Observable<PagedData<UtteranceDto>> {
    return this.httpClient.get<PagedData<UtteranceDto>>(`${this.baseUrl}/utterance/all?botId=` + botId +
      `&limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getMessageIntentList(botId: number, dateB: string, dateE: string, search: string, limit: number, offset: number,
                       sortProp: string, sortDir: string): Observable<PagedData<MessageIntentListDto>> {
    return this.httpClient.get<PagedData<MessageIntentListDto>>(`${this.baseUrl}/log/messages?botId=` + botId +
      `&limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : '') +
      (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : ''));
  }

  getMessageList(dateB: string, dateE: string, search: string, limit: number, offset: number,
                 sortProp: string, sortDir: string, userGroupId: number): Observable<PagedData<MessageIntentListDto>> {
    return this.httpClient.get<PagedData<MessageIntentListDto>>(`${this.baseUrl}/log/messages/all?limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : '') +
      (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : '') +
      (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  getXpeditionsUserList(id: number, userId: number, lang: string, dateB: string, dateE: string, search: string, limit: number,
                        offset: number, sortProp: string, sortDir: string, userGroupId: number):
    Observable<PagedData<XpeditionsUserListDto>> {
    return this.httpClient.get<PagedData<XpeditionsUserListDto>>(`${this.baseUrl}/xpedition/list/user?limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : '') +
      (dateB ? (`&dateB=` + encodeURI(dateB)) : '') + (dateE ? (`&dateE=` + encodeURI(dateE)) : '') +
      (id ? (`&xpeditionId=` + id) : '') + (userId ? (`&userId=` + userId) : '') + (lang ? (`&lang=` + lang) : '') +
      (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  exportStatisticsAsync(id: number, lang: string, dateB: string, dateE: string, search: string): Observable<any> {
    const request = new XpeditionsUserListRequest();
    request.xpeditionId = id;
    request.lang = lang;
    request.dateB = dateB;
    request.dateE = dateE;
    request.search = search;
    return this.httpClient.post<any>(`${this.baseUrl}/xpedition/export/statistics/async`, request);
  }

  getSelfInterviewList(dateB: string, dateE: string, search: string, limit: number, offset: number,
                       sortProp: string, sortDir: string, userGroupId: number): Observable<PagedData<SelfInterviewListDto>> {
    return this.httpClient.get<PagedData<SelfInterviewListDto>>(`${this.baseUrl}/selfinterview/list?limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : '') +
      (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : '') +
      (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  getUserJournalList(dateB: string, dateE: string, search: string, limit: number, offset: number,
                     sortProp: string, sortDir: string, userGroupId: number): Observable<PagedData<UserJournalListDto>> {
    return this.httpClient.get<PagedData<UserJournalListDto>>(`${this.baseUrl}/user-journal/list?limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : '') +
      (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : '') +
      (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  getTypePhraseList(search: string = null): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/slot-phrase/types`);
  }

  getSlotPhraseFormList(sffId: number): Observable<SlotPhrasesDto[]> {
    return this.httpClient.get<SlotPhrasesDto[]>(`${this.baseUrl}/slot-phrase/list/form/` + sffId);
  }

  getSlotPhraseSlotList(slotId: number): Observable<SlotPhrasesDto[]> {
    return this.httpClient.get<SlotPhrasesDto[]>(`${this.baseUrl}/slot-phrase/list/slot/` + slotId);
  }

  getSlotPhraseTransitionList(stId: number): Observable<SlotPhrasesDto[]> {
    return this.httpClient.get<SlotPhrasesDto[]>(`${this.baseUrl}/slot-phrase/list/transition/` + stId);
  }

  getSlotPhrase(id): Observable<SlotPhrasesDto> {
    return this.httpClient.get<SlotPhrasesDto>(`${this.baseUrl}/slot-phrase/` + id);
  }

  createSlotPhrase(slotPhrasesDto: SlotPhrasesDto): Observable<SlotPhrasesDto> {
    return this.httpClient.post<SlotPhrasesDto>(`${this.baseUrl}/slot-phrase/create`, slotPhrasesDto);
  }

  updateSlotPhrase(slotPhrasesDto: SlotPhrasesDto): Observable<SlotPhrasesDto> {
    return this.httpClient.post<SlotPhrasesDto>(`${this.baseUrl}/slot-phrase/update`, slotPhrasesDto);
  }

  deleteSlotPhrase(slotPhraseId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/slot-phrase/delete`, slotPhraseId);
  }

  getSlotTransitionsList(slotId: number): Observable<SlotTransitionsDto[]> {
    return this.httpClient.get<SlotTransitionsDto[]>(`${this.baseUrl}/slot-transitions/list/` + slotId);
  }

  getSlotTransitions(id): Observable<SlotTransitionsDto> {
    return this.httpClient.get<SlotTransitionsDto>(`${this.baseUrl}/slot-transitions/` + id);
  }

  createSlotTransitions(slotTransitionsDto: SlotTransitionsDto): Observable<SlotTransitionsDto> {
    return this.httpClient.post<SlotTransitionsDto>(`${this.baseUrl}/slot-transitions/create`, slotTransitionsDto);
  }

  updateSlotTransitions(slotTransitionsDto: SlotTransitionsDto): Observable<SlotTransitionsDto> {
    return this.httpClient.post<SlotTransitionsDto>(`${this.baseUrl}/slot-transitions/update`, slotTransitionsDto);
  }

  deleteSlotTransitions(stId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/slot-transitions/delete`, stId);
  }

  createYesNoTransitions(slotId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/slot-transitions/create/yes-no`, slotId);
  }

  createCategoricalTransitions(slotId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/slot-transitions/create/categorical`, slotId);
  }

  favoriteDialogue(favoriteRequest: FavoriteRequest): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/dialogue/favorite`, favoriteRequest);
  }

  unFavoriteDialogue(favoriteRequest: FavoriteRequest): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/dialogue/unfavorite`, favoriteRequest);
  }

  isFavoriteDialogue(favoriteRequest: FavoriteRequest): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrl}/dialogue/isfavorite?dialogueId=` + favoriteRequest.dialogueId
      + `&auth0Id=` + encodeURI(favoriteRequest.auth0Id));
  }

  viewDialogue(favoriteRequest: FavoriteRequest): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/dialogue/view`, favoriteRequest);
  }

  deleteTopic(typeContentId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/topic/delete`, typeContentId);
  }

  createTopic(topicListDto: TopicListDto): Observable<any> {
    return this.httpClient.post<TopicListDto>(`${this.baseUrl}/topic/create`, topicListDto);
  }

  updateTopic(topicListDto: TopicListDto): Observable<any> {
    return this.httpClient.post<TopicListDto>(`${this.baseUrl}/topic/update`, topicListDto);
  }

  getTopic(id): Observable<TopicListDto> {
    return this.httpClient.get<TopicListDto>(`${this.baseUrl}/topic/` + id);
  }

  deleteAge(ageId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/age/delete`, ageId);
  }

  createAge(ageDto: AgeDto): Observable<any> {
    return this.httpClient.post<AgeDto>(`${this.baseUrl}/age/create`, ageDto);
  }

  updateAge(ageDto: AgeDto): Observable<any> {
    return this.httpClient.post<AgeDto>(`${this.baseUrl}/age/update`, ageDto);
  }

  getAge(id): Observable<AgeDto> {
    return this.httpClient.get<AgeDto>(`${this.baseUrl}/age/` + id);
  }

  deleteReading(readingId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/reading/delete`, readingId);
  }

  createReading(readingDto: ReadingDto): Observable<any> {
    return this.httpClient.post<ReadingDto>(`${this.baseUrl}/reading/create`, readingDto);
  }

  updateReading(readingDto: ReadingDto): Observable<any> {
    return this.httpClient.post<ReadingDto>(`${this.baseUrl}/reading/update`, readingDto);
  }

  getReading(id): Observable<ReadingDto> {
    return this.httpClient.get<ReadingDto>(`${this.baseUrl}/reading/` + id);
  }

  deleteChallenge(challengeId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/challenge/delete`, challengeId);
  }

  createChallenge(challengeDto: ChallengeDto): Observable<any> {
    return this.httpClient.post<ChallengeDto>(`${this.baseUrl}/challenge/create`, challengeDto);
  }

  updateChallenge(challengeDto: ChallengeDto): Observable<any> {
    return this.httpClient.post<ChallengeDto>(`${this.baseUrl}/challenge/update`, challengeDto);
  }

  getChallenge(id): Observable<ChallengeDto> {
    return this.httpClient.get<ChallengeDto>(`${this.baseUrl}/challenge/` + id);
  }

  getAllChallengeList(search: string, limit: number, offset: number,
                      sortProp: string, sortDir: string): Observable<PagedData<ChallengeDto>> {
    return this.httpClient.get<PagedData<ChallengeDto>>(`${this.baseUrl}/challenge/challenge/list?limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getAllLifeSituationsList(search: string, limit: number, offset: number,
                           sortProp: string, sortDir: string): Observable<PagedData<ChallengeDto>> {
    return this.httpClient.get<PagedData<ChallengeDto>>(`${this.baseUrl}/challenge/situation/list?limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  deleteCategory(categoryId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/category/delete`, categoryId);
  }

  createCategory(categoryDto: CategoryDto): Observable<any> {
    return this.httpClient.post<CategoryDto>(`${this.baseUrl}/category/create`, categoryDto);
  }

  updateCategory(categoryDto: CategoryDto): Observable<any> {
    return this.httpClient.post<CategoryDto>(`${this.baseUrl}/category/update`, categoryDto);
  }

  getCategory(id): Observable<CategoryDto> {
    return this.httpClient.get<CategoryDto>(`${this.baseUrl}/category/` + id);
  }

  getAllCategoryList(search: string, limit: number, offset: number,
                     sortProp: string, sortDir: string): Observable<PagedData<CategoryDto>> {
    return this.httpClient.get<PagedData<CategoryDto>>(`${this.baseUrl}/category/list?limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getTemplateList(search: string, limit: number, offset: number,
                  sortProp: string, sortDir: string): Observable<PagedData<TypeShareDto>> {
    return this.httpClient.get<PagedData<TypeShareDto>>(`${this.baseUrl}/template/list?limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  deleteTemplate(templateId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/template/delete`, templateId);
  }

  createTemplate(templateDto: TypeShareDto): Observable<any> {
    return this.httpClient.post<TypeShareDto>(`${this.baseUrl}/template/create`, templateDto);
  }

  updateTemplate(templateDto: TypeShareDto): Observable<any> {
    return this.httpClient.post<TypeShareDto>(`${this.baseUrl}/template/update`, templateDto);
  }

  getTemplate(id): Observable<TypeShareDto> {
    return this.httpClient.get<TypeShareDto>(`${this.baseUrl}/template/` + id);
  }

  deleteEmotion(emotionId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/emotion/delete`, emotionId);
  }

  createEmotion(emotionDto: EmotionDto): Observable<any> {
    return this.httpClient.post<EmotionDto>(`${this.baseUrl}/emotion/create`, emotionDto);
  }

  updateEmotion(emotionDto: EmotionDto): Observable<any> {
    return this.httpClient.post<EmotionDto>(`${this.baseUrl}/emotion/update`, emotionDto);
  }

  getEmotion(id): Observable<EmotionDto> {
    return this.httpClient.get<EmotionDto>(`${this.baseUrl}/emotion/` + id);
  }

  getAllEmotionList(search: string, limit: number, offset: number,
                    sortProp: string, sortDir: string): Observable<PagedData<EmotionDto>> {
    return this.httpClient.get<PagedData<EmotionDto>>(`${this.baseUrl}/emotion/list?limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  deleteIntent(intentId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/intent/delete`, intentId);
  }

  createIntent(intentDto: IntentDto): Observable<any> {
    return this.httpClient.post<IntentDto>(`${this.baseUrl}/intent/create`, intentDto);
  }

  updateIntent(intentDto: IntentDto): Observable<any> {
    return this.httpClient.post<IntentDto>(`${this.baseUrl}/intent/update`, intentDto);
  }

  getIntent(id): Observable<IntentDto> {
    return this.httpClient.get<IntentDto>(`${this.baseUrl}/intent/` + id);
  }

  getAllIntentList(search: string, limit: number, offset: number,
                   sortProp: string, sortDir: string): Observable<PagedData<IntentDto>> {
    return this.httpClient.get<PagedData<IntentDto>>(`${this.baseUrl}/intent/list?limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getContentDashboardEmotions(): Observable<ContentEmotions[]> {
    return this.httpClient.get<ContentEmotions[]>(`${this.baseUrl}/content/dashboard/emotions`);
  }

  getContentDashboardTopics(): Observable<ContentTopics[]> {
    return this.httpClient.get<ContentTopics[]>(`${this.baseUrl}/content/dashboard/topics`);
  }

  getGroupBotList(botId): Observable<GroupBotDto[]> {
    return this.httpClient.get<GroupBotDto[]>(`${this.baseUrl}/group-bot/list/` + botId);
  }

  getGroupBot(id): Observable<GroupBotDto> {
    return this.httpClient.get<GroupBotDto>(`${this.baseUrl}/group-bot/` + id);
  }

  createGroupBot(groupBot: GroupBotDto): Observable<GroupBotDto> {
    return this.httpClient.post<GroupBotDto>(`${this.baseUrl}/group-bot/create`, groupBot);
  }

  updateGroupBot(groupBot: GroupBotDto): Observable<GroupBotDto> {
    return this.httpClient.post<GroupBotDto>(`${this.baseUrl}/group-bot/update`, groupBot);
  }

  deleteGroupBot(groupBot: GroupBotDto): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/group-bot/delete`, groupBot);
  }

  getErrorList(botId: number, search: string, limit: number, offset: number,
               sortProp: string, sortDir: string, filter: ErrorFilter): Observable<PagedData<DialogueErrorListDto>> {
    return this.httpClient.post<PagedData<DialogueErrorListDto>>(`${this.baseUrl}/error/list`,
      new ErrorListRequest(botId, search, limit, offset, sortProp, sortDir, filter));
  }

  resolveError(deId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/error/resolve`, deId);
  }

  closeError(deId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/error/close`, deId);
  }

  approveUser(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/school/pro/approve`, id);
  }

  denyUser(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/school/pro/deny`, id);
  }

  getTypeErrorList(search: string = null): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/error/types`);
  }

  runAnalysis(botId: number, tdeIds: number[]): Observable<Dictionary[]> {
    return this.httpClient.post<any>(`${this.baseUrl}/error/run`, new RunAnalysisRequest(botId, tdeIds));
  }

  runAnalysisChallenge(): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/error/run/challenges`, '');
  }

  runAnalysisEmotion(): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/error/run/emotions`, '');
  }

  runAnalysisQuestionnaire(): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/error/run/questionnaire`, '');
  }

  getProcedureList(search: string, limit: number, offset: number, sortProp: string,
                   sortDir: string, filter: ProcedureFilter,): Observable<PagedData<ProcedureListDto>> {
    return this.httpClient.post<PagedData<ProcedureListDto>>(`${this.baseUrl}/procedure/list`,
      new ProcedureListRequest(search, limit, offset, sortProp, sortDir, filter));
  }

  getProcedure(procedureId): Observable<ProcedureDto> {
    return this.httpClient.get<ProcedureDto>(`${this.baseUrl}/procedure/` + procedureId);
  }

  createProcedure(procedure: ProcedureDto): Observable<ProcedureDto> {
    return this.httpClient.post<ProcedureDto>(`${this.baseUrl}/procedure/create`, procedure);
  }

  updateProcedure(procedure: ProcedureDto): Observable<ProcedureDto> {
    return this.httpClient.post<ProcedureDto>(`${this.baseUrl}/procedure/update`, procedure);
  }

  deleteProcedure(procedureId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/procedure/delete`, procedureId);
  }

  testGroovyScript(request: GroovyCompilerDto): Observable<GroovyCompilerDto> {
    return this.httpClient.post<GroovyCompilerDto>(`${this.baseUrl}/procedure/test`, request);
  }

  deleteAllUserDialogues(userId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/dialogue/delete/user`, userId);
  }

  blockUser(userId: number, block: boolean): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/user/block`, {userId, block});
  }

  getTypeProcedureList(search: string = null): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/procedure/types`);
  }

  getStatisticChallengesList(dateB: string, dateE: string, search: string, limit: number, offset: number,
                             sortProp: string, sortDir: string, userGroupId: number): Observable<PagedData<Statistic>> {
    return this.httpClient.get<PagedData<Statistic>>(`${this.baseUrl}/statistic/challenges?limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : '') +
      (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : '') +
      (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  getStatisticEmotionsList(dateB: string, dateE: string, search: string, limit: number, offset: number,
                           sortProp: string, sortDir: string, userGroupId: number): Observable<PagedData<Statistic>> {
    return this.httpClient.get<PagedData<Statistic>>(`${this.baseUrl}/statistic/emotions?limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : '') +
      (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : '') +
      (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  getStatisticQuestionnaireList(dateB: string, dateE: string, search: string, limit: number, offset: number,
                                sortProp: string, sortDir: string, userGroupId: number): Observable<PagedData<Statistic>> {
    return this.httpClient.get<PagedData<Statistic>>(`${this.baseUrl}/statistic/questionnaire?limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : '') +
      (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : '') +
      (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  getQuestionnaireReport(sffId: number, dateB: string, dateE: string, search: string, limit: number, offset: number,
                         sortProp: string, sortDir: string, userGroupId: number): Observable<PagedData<QuestionnaireReportDto>> {
    return this.httpClient.get<PagedData<QuestionnaireReportDto>>(`${this.baseUrl}/statistic/questionnaire/report?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : '') +
      (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : '') +
      (sffId ? (`&sffId=` + sffId) : '') +
      (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  getQuestionnaireReportCSV(sffId: number, dateB: string, dateE: string, search: string, userGroupId: number): Observable<ExportResult> {
    return this.httpClient.get<ExportResult>(`${this.baseUrl}/statistic/questionnaire/report/csv?sffId=` + sffId +
      (search ? (`&search=` + encodeURI(search)) : '') +
      (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : '') +
      (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  getBotTaskSettingsList(botId: number): Observable<BotTaskSettings[]> {
    return this.httpClient.get<BotTaskSettings[]>(`${this.baseUrl}/bot/settings/list/` + botId);
  }

  getBotTaskSettings(id): Observable<BotTaskSettings> {
    return this.httpClient.get<BotTaskSettings>(`${this.baseUrl}/bot/settings/` + id);
  }

  createBotTaskSettings(settings: BotTaskSettings): Observable<BotTaskSettings> {
    return this.httpClient.post<BotTaskSettings>(`${this.baseUrl}/bot/settings/create`, settings);
  }

  updateBotTaskSettings(settings: BotTaskSettings): Observable<BotTaskSettings> {
    return this.httpClient.post<BotTaskSettings>(`${this.baseUrl}/bot/settings/update`, settings);
  }

  deleteBotTaskSettings(settings: BotTaskSettings): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/bot/settings/delete`, settings.id);
  }

  reloadConfidences(botId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/bot/confidence/reload`, botId);
  }

  deleteDelivery(deliveryId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/delivery/delete`, deliveryId);
  }

  createDelivery(deliveryDto: DeliveryDto): Observable<any> {
    return this.httpClient.post<DeliveryDto>(`${this.baseUrl}/delivery/create`, deliveryDto);
  }

  updateDelivery(deliveryDto: DeliveryDto): Observable<any> {
    return this.httpClient.post<DeliveryDto>(`${this.baseUrl}/delivery/update`, deliveryDto);
  }

  getDelivery(id): Observable<DeliveryDto> {
    return this.httpClient.get<DeliveryDto>(`${this.baseUrl}/delivery/` + id);
  }

  getAllDeliveryList(botId: number, search: string, limit: number, offset: number,
                     sortProp: string, sortDir: string): Observable<PagedData<DeliveryDto>> {
    return this.httpClient.get<PagedData<DeliveryDto>>(`${this.baseUrl}/delivery/list?botId=` + botId + `&limit=`
      + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  deleteContentSet(setId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/content-set/delete`, setId);
  }

  createContentSet(contentSetDto: ContentSetDto): Observable<any> {
    return this.httpClient.post<ContentSetDto>(`${this.baseUrl}/content-set/create`, contentSetDto);
  }

  updateContentSet(contentSetDto: ContentSetDto): Observable<any> {
    return this.httpClient.post<ContentSetDto>(`${this.baseUrl}/content-set/update`, contentSetDto);
  }

  getContentSet(id): Observable<ContentSetDto> {
    return this.httpClient.get<ContentSetDto>(`${this.baseUrl}/content-set/` + id);
  }

  getContentSetListById(setId): Observable<ContentSetDto[]> {
    return this.httpClient.get<ContentSetDto[]>(`${this.baseUrl}/content-set/list/` + setId);
  }

  createContentSetLang(contentSet: ContentSetDto, lang: string, translateToLang: boolean): Observable<ContentSetDto> {
    return this.httpClient.post<ContentSetDto>(`${this.baseUrl}/content-set/create/translated`, {
      contentSet,
      lang,
      translateToLang
    });
  }

  // TODO - customerId
  getContentSetList(search: string, limit: number, offset: number,
                    sortProp: string, sortDir: string): Observable<PagedData<ContentSetDto>> {
    return this.httpClient.get<PagedData<ContentSetDto>>(`${this.baseUrl}/content-set/list?limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getTypeSetList(search: string = null): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/content-set/types`);
  }

  getSetPartsList(setId: number): Observable<ContentSetPartListDto[]> {
    return this.httpClient.get<ContentSetPartListDto[]>(`${this.baseUrl}/content-set/parts/` + setId);
  }

  deleteSetComposition(setId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/set-composition/delete`, setId);
  }

  createSetComposition(setCompositionDto: SetCompositionDto): Observable<any> {
    return this.httpClient.post<SetCompositionDto>(`${this.baseUrl}/set-composition/create`, setCompositionDto);
  }

  updateSetComposition(setCompositionDto: SetCompositionDto): Observable<any> {
    return this.httpClient.post<SetCompositionDto>(`${this.baseUrl}/set-composition/update`, setCompositionDto);
  }

  getSetComposition(id): Observable<SetCompositionDto> {
    return this.httpClient.get<SetCompositionDto>(`${this.baseUrl}/set-composition/` + id);
  }

  getSetCompositionList(setId: number): Observable<SetCompositionListDto[]> {
    return this.httpClient.get<SetCompositionListDto[]>(`${this.baseUrl}/set-composition/list/` + setId);
  }

  deleteJournalPage(journalPageId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/journal-page/delete`, journalPageId);
  }

  createJournalPage(journalPageDto: JournalPageDto): Observable<any> {
    return this.httpClient.post<JournalPageDto>(`${this.baseUrl}/journal-page/create`, journalPageDto);
  }

  updateJournalPage(journalPageDto: JournalPageDto): Observable<any> {
    return this.httpClient.post<JournalPageDto>(`${this.baseUrl}/journal-page/update`, journalPageDto);
  }

  getJournalPage(id): Observable<JournalPageDto> {
    return this.httpClient.get<JournalPageDto>(`${this.baseUrl}/journal-page/` + id);
  }

  getJournalPageList(contentId: number): Observable<JournalPageDto[]> {
    return this.httpClient.get<JournalPageDto[]>(`${this.baseUrl}/journal-page/list/` + contentId);
  }

  getJournalPageListById(id: number): Observable<JournalPageDto[]> {
    return this.httpClient.get<JournalPageDto[]>(`${this.baseUrl}/journal-page/lang/list/` + id);
  }


  getUserJournalTextList(viewId: number): Observable<UserJournalDto[]> {
    return this.httpClient.get<UserJournalDto[]>(`${this.baseUrl}/user-journal/user-text/` + viewId);
  }

  getUserPersonalityTraits(viewId: number, userId: number): Observable<PersonalityTraitsResponse> {
    return this.httpClient.get<PersonalityTraitsResponse>(`${this.baseUrl}/user-journal/personality-traits/` + viewId + `/` + userId);
  }

  exportPersonalityTraitsXlsx(viewId: number, userId: number): Observable<ExportResult> {
    return this.httpClient.post<ExportResult>(`${this.baseUrl}/user-journal/personality-traits/export/xlsx`, {
      viewId,
      userId
    });
  }

  deleteContentMedia(contentMediaId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/content-media/delete`, contentMediaId);
  }

  createContentMedia(contentMediaDto: ContentMediaDto): Observable<any> {
    return this.httpClient.post<ContentMediaDto>(`${this.baseUrl}/content-media/create`, contentMediaDto);
  }

  updateContentMedia(contentMediaDto: ContentMediaDto): Observable<any> {
    return this.httpClient.post<ContentMediaDto>(`${this.baseUrl}/content-media/update`, contentMediaDto);
  }

  getContentMedia(id): Observable<ContentMediaDto> {
    return this.httpClient.get<ContentMediaDto>(`${this.baseUrl}/content-media/` + id);
  }

  getContentMediaList(contentId: number): Observable<ContentMediaDto[]> {
    return this.httpClient.get<ContentMediaDto[]>(`${this.baseUrl}/content-media/list/` + contentId);
  }

  getLangList(): Observable<Language[]> {
    return this.httpClient.get<Language[]>(`${this.baseUrl}/language/list`);
  }

  getCustomerList(): Observable<CustomerDto[]> {
    return this.httpClient.get<CustomerDto[]>(`${this.baseUrl}/customer/list`);
  }

  getCustomerByAuth0Id(id): Observable<CustomerDto> {
    return this.httpClient.post<CustomerDto>(`${this.baseUrl}/customer/admin`, {id});
  }

  getCustomerById(id): Observable<CustomerDto> {
    return this.httpClient.get<CustomerDto>(`${this.baseUrl}/customer/` + id);
  }

  getCustomerDialogueCount(id): Observable<NumberResponse> {
    return this.httpClient.get<NumberResponse>(`${this.baseUrl}/customer/dialogues/` + id);
  }

  changeCustomer(customerId): Observable<CustomerDto> {
    return this.httpClient.post<CustomerDto>(`${this.baseUrl}/admin/user/change/customer`, {customerId});
  }

  createCustomer(customer: CustomerDto): Observable<CustomerDto> {
    return this.httpClient.post<CustomerDto>(`${this.baseUrl}/customer/create`, customer);
  }

  updateCustomer(customer: CustomerDto): Observable<CustomerDto> {
    return this.httpClient.post<CustomerDto>(`${this.baseUrl}/customer/update`, customer);
  }

  getAllCustomerList(search: string, limit: number, offset: number,
                     sortProp: string, sortDir: string): Observable<PagedData<CustomerListDto>> {
    return this.httpClient.get<PagedData<CustomerListDto>>(`${this.baseUrl}/customer/list/all?limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getUserMaterialsList(userId: number, search: string, limit: number, offset: number,
                       sortProp: string, sortDir: string): Observable<PagedData<UserMaterialsDto>> {
    return this.httpClient.get<PagedData<UserMaterialsDto>>(`${this.baseUrl}/school/materials/list?userId=` + userId +
      `&limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getUserShareList(userId: number, search: string, limit: number, offset: number,
                   sortProp: string, sortDir: string): Observable<PagedData<ShareListDto>> {
    return this.httpClient.get<PagedData<ShareListDto>>(`${this.baseUrl}/share/list?userId=` + userId +
      `&limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getAllShareList(search: string, limit: number, offset: number,
                  sortProp: string, sortDir: string): Observable<PagedData<ShareListDto>> {
    return this.httpClient.get<PagedData<ShareListDto>>(`${this.baseUrl}/share/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getSharedContentsList(shareId: number, search: string, limit: number, offset: number,
                        sortProp: string, sortDir: string): Observable<PagedData<UserMaterialsDto>> {
    return this.httpClient.get<PagedData<UserMaterialsDto>>(`${this.baseUrl}/share/content/list?shareId=` + shareId +
      `&limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getSharedResourceList(shareId: number, search: string, limit: number, offset: number,
                        sortProp: string, sortDir: string): Observable<PagedData<UserMaterialsDto>> {
    return this.httpClient.get<PagedData<UserMaterialsDto>>(`${this.baseUrl}/share/resource/list?shareId=` + shareId +
      `&limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getRecipientsList(shareId: number, search: string, limit: number, offset: number,
                    sortProp: string, sortDir: string): Observable<PagedData<RecipientsDto>> {
    return this.httpClient.get<PagedData<RecipientsDto>>(`${this.baseUrl}/share/recipient/list?shareId=` + shareId +
      `&limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getXpeditionList(search: string, limit: number, offset: number, sortProp: string, sortDir: string):
    Observable<PagedData<XpeditionListDto>> {
    return this.httpClient.get<PagedData<XpeditionListDto>>(`${this.baseUrl}/xpedition/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getXpeditionById(id: number): Observable<XpeditionDto> {
    return this.httpClient.get<XpeditionDto>(`${this.baseUrl}/xpedition/` + id);
  }

  getXpeditionByLang(id, lang): Observable<XpeditionDto> {
    return this.httpClient.get<XpeditionDto>(`${this.baseUrl}/xpedition/` + id + `/` + lang);
  }

  getXpeditionListById(id): Observable<XpeditionDto[]> {
    return this.httpClient.get<XpeditionDto[]>(`${this.baseUrl}/xpedition/list/` + id);
  }

  getXpeditionExerciseList(): Observable<XpeditionExerciseListDto[]> {
    return this.httpClient.get<XpeditionExerciseListDto[]>(`${this.baseUrl}/xpedition/exercise/list`);
  }

  createXpedition(xpedition: XpeditionDto): Observable<XpeditionDto> {
    return this.httpClient.post<XpeditionDto>(`${this.baseUrl}/xpedition/create`, xpedition);
  }

  createXpeditionLang(xpedition: XpeditionDto, lang: string, translateToLang: boolean): Observable<XpeditionDto> {
    return this.httpClient.post<XpeditionDto>(`${this.baseUrl}/xpedition/create/translated`, {
      xpedition,
      lang,
      translateToLang
    });
  }

  updateXpedition(xpedition: XpeditionDto): Observable<XpeditionDto> {
    return this.httpClient.post<XpeditionDto>(`${this.baseUrl}/xpedition/update`, xpedition);
  }

  deleteXpedition(xpeditionId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/xpedition/delete`, xpeditionId);
  }

  getContentXQuestions(contentId: number, typeId: number, lang: string):
    Observable<XpeditionQuestionDto[]> {
    return this.httpClient.get<XpeditionQuestionDto[]>(`${this.baseUrl}/content/question/list/` + contentId + `/` + typeId +
      `/` + lang);
  }

  getXQuestions(xpeditionId: number, typeId: number, lang: string):
    Observable<XpeditionQuestionDto[]> {
    return this.httpClient.get<XpeditionQuestionDto[]>(`${this.baseUrl}/xpedition/question/list/` + xpeditionId + `/` + typeId +
      `/` + lang);
  }

  getXQuestionById(id: number): Observable<XpeditionQuestionDto> {
    return this.httpClient.get<XpeditionQuestionDto>(`${this.baseUrl}/xpedition/question/` + id);
  }

  getTypeXQuestions4Contents():
    Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/xpedition/question/type/list/CONTENT`);
  }

  getTypeXQuestions4Xpeditions():
    Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/xpedition/question/type/list/XPEDITION`);
  }

  createXQuestion(xquestion: XpeditionQuestionDto): Observable<XpeditionQuestionDto> {
    return this.httpClient.post<XpeditionQuestionDto>(`${this.baseUrl}/xpedition/question/create`, xquestion);
  }

  updateXQuestion(xquestion: XpeditionQuestionDto): Observable<XpeditionQuestionDto> {
    return this.httpClient.post<XpeditionQuestionDto>(`${this.baseUrl}/xpedition/question/update`, xquestion);
  }

  deleteXQuestion(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/xpedition/question/delete`, id);
  }

  getXContents(xpeditionId: number, typeId: number): Observable<XpeditionContentDto[]> {
    return this.httpClient.get<XpeditionContentDto[]>(`${this.baseUrl}/xpedition/content/list/` + xpeditionId + `/` + typeId);
  }

  getXContentById(id: number): Observable<XpeditionContentDto> {
    return this.httpClient.get<XpeditionContentDto>(`${this.baseUrl}/xpedition/content/` + id);
  }

  getTypeXContents(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/xpedition/content/type/list`);
  }

  createXContent(xquestion: XpeditionContentDto): Observable<XpeditionContentDto> {
    return this.httpClient.post<XpeditionContentDto>(`${this.baseUrl}/xpedition/content/create`, xquestion);
  }

  updateXContent(xquestion: XpeditionContentDto): Observable<XpeditionContentDto> {
    return this.httpClient.post<XpeditionContentDto>(`${this.baseUrl}/xpedition/content/update`, xquestion);
  }

  deleteXContent(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/xpedition/content/delete`, id);
  }

  createQuestionAnswer(questionAnswer: QuestionAnswerDto): Observable<QuestionAnswerDto> {
    return this.httpClient.post<QuestionAnswerDto>(`${this.baseUrl}/question-answers/create`, questionAnswer);
  }

  updateQuestionAnswer(questionAnswer: QuestionAnswerDto): Observable<QuestionAnswerDto> {
    return this.httpClient.post<QuestionAnswerDto>(`${this.baseUrl}/question-answers/update`, questionAnswer);
  }

  deleteQuestionAnswer(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/question-answers/delete`, id);
  }

  getQuestionAnswers(xquestionId: number, lang: string):
    Observable<QuestionAnswerDto[]> {
    return this.httpClient.get<QuestionAnswerDto[]>(`${this.baseUrl}/question-answers/list/` + xquestionId + `/` + lang);
  }

  getQuestionAnswerById(id: number): Observable<QuestionAnswerDto> {
    return this.httpClient.get<QuestionAnswerDto>(`${this.baseUrl}/question-answers/` + id);
  }

  getXpeditionDialogueReport(id: number, template: string, type: string, fileName?: string): Observable<ExportResult> {
    return this.httpClient.get<ExportResult>(`${this.baseUrl}/report/xpedition/dialogue/${id}/${template}/${type}`
      + (fileName ? (`?fileName=` + encodeURI(fileName)) : '')
    );
  }

  exportXpeditionsDialogueToXls(xpeditionId: number, template: string, dateB: string, dateE: string, search: string,
                                limit: number, offset: number, sortProp: string, sortDir: string): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrl}/report/xpedition/all/${template}?limit=${limit}&offset=${offset}`
      + (sortProp ? (`&sortProp=${sortProp}&sortDir=${sortDir}`) : '') + (search ? (`&search=` + encodeURI(search)) : '') +
      (dateB ? (`&dateB=` + encodeURI(dateB)) : '') + (dateE ? (`&dateE=` + encodeURI(dateE)) : '') +
      (xpeditionId ? (`&xpeditionId=` + xpeditionId) : ''));

  }

  getContactLists(customerId: number, search: string, limit: number,
                  offset: number, sortProp: string, sortDir: string): Observable<PagedData<ContactListDto>> {
    return this.httpClient.get<PagedData<ContactListDto>>(`${this.baseUrl}/contacts/lists?customerId=${customerId}&limit=${limit}&offset=${offset}`
      + (sortProp ? (`&sortProp=${sortProp}&sortDir=${sortDir}`) : '') + (search ? `&search=${encodeURI(search)}` : ''));
  }

  getContactsInList(listId: number, search: string, limit: number,
                    offset: number, sortProp: string, sortDir: string): Observable<PagedData<UserInListDto>> {
    return this.httpClient.get<PagedData<UserInListDto>>(`${this.baseUrl}/contacts/in/list?listId=${listId}&limit=${limit}&offset=${offset}`
      + (sortProp ? (`&sortProp=${sortProp}&sortDir=${sortDir}`) : '') + (search ? `&search=${encodeURI(search)}` : ''));
  }

  getContactListById(id: number): Observable<ContactListDto> {
    return this.httpClient.get<ContactListDto>(`${this.baseUrl}/contacts/list/` + id);
  }

  createContactList(contactList: ContactListDto): Observable<ContactListDto> {
    return this.httpClient.post<ContactListDto>(`${this.baseUrl}/contacts/list/create`, contactList);
  }

  updateContactList(contactList: ContactListDto): Observable<ContactListDto> {
    return this.httpClient.post<ContactListDto>(`${this.baseUrl}/contacts/list/update`, contactList);
  }

  deleteContactList(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/contacts/list/delete`, id);
  }

  addUserToContactList(userInList: UserInListDto): Observable<UserInListDto> {
    return this.httpClient.post<UserInListDto>(`${this.baseUrl}/contacts/list/add`, userInList);
  }

  createUserInContactList(contactUserCard: ContactUserCard, listId: number): Observable<UserInListDto> {
    const userInListDto = new UserInListDto();
    userInListDto.setContactUserCard(contactUserCard);
    userInListDto.listId = listId;
    return this.httpClient.post<UserInListDto>(`${this.baseUrl}/contacts/user/create`, userInListDto);
  }

  updateUserInContactList(contactUserCard: ContactUserCard, listId: number): Observable<UserInListDto> {
    const userInListDto = new UserInListDto();
    userInListDto.setContactUserCard(contactUserCard);
    userInListDto.listId = listId;
    return this.httpClient.post<UserInListDto>(`${this.baseUrl}/contacts/user/update`, userInListDto);
  }

  deleteUser(userId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/user/delete`, userId);
  }

  checkUserInList(userInList: UserInListDto): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/contacts/list/check`, userInList);
  }

  checkUser(contactUserCard: ContactUserCard, listId: number): Observable<any> {
    const userInListDto = new UserInListDto();
    userInListDto.setContactUserCard(contactUserCard);
    userInListDto.listId = listId;
    return this.httpClient.post<any>(`${this.baseUrl}/contacts/user/check`, userInListDto);
  }

  removeUserFromContactList(inListId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/contacts/list/remove`, inListId);
  }

  getContactSources(customerId: number): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/contacts/sources/` + customerId);
  }

  uploadContacts(sourceId: number, listId: number, customerId: number, file: string, fileName: string): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/contacts/list/upload`, {
      sourceId,
      listId,
      customerId,
      file,
      fileName
    });
  }

  getContactListDictionary(search: string = null): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/sending/contact/list`
      + (search ? (`?search=` + encodeURI(search)) : ''));
  }


  getChannels(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/sending/channels`);
  }

  getConnectors(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/sending/connectors`);
  }

  getEmailSendingList(type: string, search: string, limit: number, offset: number,
                      sortProp: string, sortDir: string): Observable<PagedData<SendingListDto>> {
    return this.httpClient.get<PagedData<SendingListDto>>(`${this.baseUrl}/sending/list?limit=` + limit
      + `&type=` + type + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + (sortDir ? sortDir : `asc`)) : ``)
      + (search ? (`&search=` + encodeURI(search)) : ``));
  }

  getSending(id): Observable<SendingDto> {
    return this.httpClient.get<SendingDto>(`${this.baseUrl}/sending/` + id);
  }

  createSending(sendingDto: SendingDto): Observable<SendingDto> {
    return this.httpClient.post<SendingDto>(`${this.baseUrl}/sending/create`, sendingDto);
  }

  updateSending(sendingDto: SendingDto): Observable<SendingDto> {
    return this.httpClient.post<SendingDto>(`${this.baseUrl}/sending/update`, sendingDto);
  }

  deleteSending(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/sending/delete`, id);
  }

  startSending(sendingId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/sending/start`, {sendingId});
  }

  copySending(sendingId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/sending/copy`, {sendingId});
  }

  getSendingStatisticByType(sendingId: number): Observable<Statistic[]> {
    return this.httpClient.get<Statistic[]>(`${this.baseUrl}/sending/stat/type/` + sendingId);
  }

  getSendingContactEvents(sendingId: number, taeName: string, search: string, limit: number, offset: number,
                          sortProp: string, sortDir: string): Observable<PagedData<SendingContactsEventDto>> {
    return this.httpClient.get<PagedData<SendingContactsEventDto>>(`${this.baseUrl}/sending/contact/events/` +
      sendingId + `/` + taeName + `?limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + (sortDir ? sortDir : `asc`)) : '')
      + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getSendingStatistics(): Observable<SendingMetricsDto> {
    return this.httpClient.get<SendingMetricsDto>(`${this.baseUrl}/sending/stat`);
  }

  getSendingMetrics(sendingId: number): Observable<SendingMetricsDto> {
    return this.httpClient.get<SendingMetricsDto>(`${this.baseUrl}/sending/metrics/` + sendingId);
  }

  getSendingClickedLinks(sendingId: number): Observable<SendingClickedLinksDto[]> {
    return this.httpClient.get<SendingClickedLinksDto[]>(`${this.baseUrl}/sending/links/` + sendingId);
  }

  getExchangesInList(listId: number, typeExchangeId: number, customerId: number, search: string, limit: number,
                     offset: number, sortProp: string, sortDir: string): Observable<PagedData<ExchangeDto>> {
    return this.httpClient.get<PagedData<ExchangeDto>>(`${this.baseUrl}/contacts/exchanges?listId=${listId}&typeExchangeId=${typeExchangeId}`
      + `&customerId=${customerId}&limit=${limit}&offset=${offset}&isUserList=false`
      + (sortProp ? (`&sortProp=${sortProp}&sortDir=${sortDir}`) : '')
      + (search ? `&search=${encodeURI(search)}` : ''));
  }

  getExchanges(isUserList: boolean, typeExchangeId: number, customerId: number, search: string, limit: number,
               offset: number, sortProp: string, sortDir: string): Observable<PagedData<ExchangeDto>> {
    return this.httpClient.get<PagedData<ExchangeDto>>(`${this.baseUrl}/contacts/exchanges?typeExchangeId=${typeExchangeId}&limit=${limit}&offset=${offset}`
      + (customerId ? `&customerId=${customerId}` : ``)
      + (sortProp ? (`&sortProp=${sortProp}&sortDir=${sortDir}`) : '')
      + (search ? `&search=${encodeURI(search)}` : '')
      + `&isUserList=${isUserList}`);
  }

  getContactListSendings(listId: number): Observable<SendingListDto[]> {
    return this.httpClient.get<SendingListDto[]>(`${this.baseUrl}/sending/list/${listId}`);
  }

  getAllContacts(search: string, limit: number, offset: number,
                 sortProp: string, sortDir: string): Observable<PagedData<ContactUserDto>> {
    return this.httpClient.get<PagedData<ContactUserDto>>(`${this.baseUrl}/contacts/user/list?limit=` + limit
      + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + (sortDir ? sortDir : `asc`)) : '')
      + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getContactUserById(id: number): Observable<ContactUserCard> {
    return this.httpClient.get<ContactUserCard>(`${this.baseUrl}/contacts/user/${id}`);
  }

  getContactListByUserId(id: number): Observable<ContactListDto[]> {
    return this.httpClient.get<ContactListDto[]>(`${this.baseUrl}/contacts/list/user/` + id);
  }

  exportContacts({listId, customerId, sendingId, typeEventNames}: ExportContactsDto): Observable<StringResponse> {
    return this.httpClient.post<StringResponse>(`${this.baseUrl}/contacts/export`, {
      listId,
      customerId,
      sendingId,
      typeEventNames
    });
  }

  getSuppressionList(types: Dictionary[], search: string, limit: number, offset: number,
                     sortProp: string, sortDir: string): Observable<PagedData<SuppressionListDto>> {
    const typesStr = types.map((d) => d.id).join(',');
    return this.httpClient.get<PagedData<SuppressionListDto>>(`${this.baseUrl}/sending/suppression/list?limit=` + limit
      + `&offset=` + offset + (typesStr && typesStr !== '' ? `&types=` + typesStr : '')
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + (sortDir ? sortDir : `asc`)) : '')
      + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getSuppressionTypeEvents(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/sending/suppression/type/events`);
  }

  getSendingTypes(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/sending/types`);
  }

  exportContactsAsync({
                        listId,
                        customerId,
                        sendingId,
                        typeEventNames,
                        exportFileName
                      }: ExportContactsDto): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/contacts/export/async`, {
      listId, customerId, sendingId,
      typeEventNames, exportFileName
    });
  }

  updateUserMetadata(userId: number, userMetadata: UserMetadata[]): Observable<UserMetadata[]> {
    return this.httpClient.post<UserMetadata[]>(`${this.baseUrl}/contacts/user/metadata/update`, {
      userId,
      userMetadata
    });
  }

  deleteExport(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/contacts/export/delete`, id);
  }

  getSendingEvents(customerId: number, sendingId: number, typeEventIds: number[], dateB: string, dateE: string,
                   search: string, limit: number, offset: number, sortProp: string, sortDir: string):
    Observable<PagedData<SendingContactsEventDto>> {
    return this.httpClient.get<PagedData<SendingContactsEventDto>>(`${this.baseUrl}/sending/event/list?customerId=${customerId}` +
      (sendingId ? `&sendingId=${sendingId}` : '') +
      (typeEventIds ? `&typeEventIds=${typeEventIds}` : '') +
      (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : '') +
      `&limit=${limit}&offset=${offset}` +
      (sortProp ? (`&sortProp=${sortProp}&sortDir=${sortDir}`) : '') +
      (search ? `&search=${encodeURI(search)}` : ''));
  }

  getSendingTypeEvents(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/sending/type/events`);
  }

  getSendingDictionary(customerId: number): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/sending/dict?customerId=${customerId}`);
  }

  getStatisticsFullList(search: string): Observable<StatisticsParameterDto[]> {
    return this.httpClient.get<StatisticsParameterDto[]>(`${this.baseUrl}/statistics/full/list` +
      (search ? `?search=${encodeURI(search)}` : ''));
  }

  getStatisticsTypes(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/statistics/types`);
  }

  getStatisticsList(search: string, limit: number, offset: number, sortProp: string, sortDir: string)
    : Observable<PagedData<StatisticsParameterDto>> {
    return this.httpClient.get<PagedData<StatisticsParameterDto>>(`${this.baseUrl}/statistics/list?limit=${limit}&offset=${offset}` +
      (sortProp ? (`&sortProp=${sortProp}&sortDir=${sortDir}`) : '') +
      (search ? `&search=${encodeURI(search)}` : ''));
  }

  getStatisticsById(id: number): Observable<StatisticsParameterDto> {
    return this.httpClient.get<StatisticsParameterDto>(`${this.baseUrl}/statistics/${id}`);
  }

  createStatistics(statisticsParameterDto: StatisticsParameterDto): Observable<StatisticsParameterDto> {
    return this.httpClient.post<StatisticsParameterDto>(`${this.baseUrl}/statistics/create`, statisticsParameterDto);
  }

  updateStatistics(statisticsParameterDto: StatisticsParameterDto): Observable<StatisticsParameterDto> {
    return this.httpClient.post<StatisticsParameterDto>(`${this.baseUrl}/statistics/update`, statisticsParameterDto);
  }

  deleteStatistics(statisticsParameterDto: StatisticsParameterDto): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/statistics/delete`, statisticsParameterDto);
  }

  getBotStatisticsList(botId: number, search: string, limit: number, offset: number, sortProp: string, sortDir: string)
    : Observable<PagedData<BotStatisticsDto>> {
    return this.httpClient.get<PagedData<BotStatisticsDto>>(`${this.baseUrl}/statistics/bot/${botId}?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getStatisticsValues(botId: number, spId: number, dateB: string, dateE: string, limit: number, offset: number)
    : Observable<PagedData<StatisticsValueDto>> {
    return this.httpClient.get<PagedData<StatisticsValueDto>>(`${this.baseUrl}/statistics/values?spId=${spId}` +
      `&botId=${botId}&limit=${limit}&offset=${offset}` +
      (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : ''));
  }

  updateBotStatistics(botId: number, dateFrom: string, dateTo: string, spIds: number[]): Observable<any> {
    const request = new UpdateStatisticRequest(botId, dateFrom, dateTo, spIds);
    return this.httpClient.post<any>(`${this.baseUrl}/statistics/bot/update`, request);
  }

  getAllDialogueLabels(search: string): Observable<LabelDto[]> {
    return this.httpClient.get<LabelDto[]>(`${this.baseUrl}/label/list/dialogue` +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getAllMessageLabels(search: string): Observable<LabelDto[]> {
    return this.httpClient.get<LabelDto[]>(`${this.baseUrl}/label/list/message` +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getDialogueLabels(id: number): Observable<LabelDto[]> {
    return this.httpClient.get<LabelDto[]>(`${this.baseUrl}/label/dialogue/list/${id}`);
  }

  addDialogueLabels(id: number, auId: number, labelIds: number[]): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/label/dialogue/add`, {id, auId, labelIds});
  }

  deleteDialogueLabels(id: number, auId: number, labelIds: number[]): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/label/dialogue/delete`, {id, auId, labelIds});
  }

  getMessageLabels(id: number): Observable<LabelDto[]> {
    return this.httpClient.get<LabelDto[]>(`${this.baseUrl}/label/message/list/${id}`);
  }

  addMessageLabels(id: number, auId: number, labelIds: number[]): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/label/message/add`, {id, auId, labelIds});
  }

  deleteMessageLabels(id: number, auId: number, labelIds: number[]): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/label/message/delete`, {id, auId, labelIds});
  }

  getLabelList(search: string, limit: number, offset: number, sortProp: string, sortDir: string)
    : Observable<PagedData<LabelDto>> {
    return this.httpClient.get<PagedData<LabelDto>>(`${this.baseUrl}/label/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getLabelTypes(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/label/types`);
  }

  getLabel(id): Observable<LabelDto> {
    return this.httpClient.get<LabelDto>(`${this.baseUrl}/label/${id}`);
  }

  addLabel(label: LabelDto): Observable<LabelDto> {
    return this.httpClient.post<LabelDto>(`${this.baseUrl}/label/create`, label);
  }

  updateLabel(label: LabelDto): Observable<LabelDto> {
    return this.httpClient.post<LabelDto>(`${this.baseUrl}/label/update`, label);
  }

  deleteLabel(label: LabelDto): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/label/delete`, label);
  }

  getDialogueCommentList(dialogId: number): Observable<CommentDto[]> {
    return this.httpClient.get<CommentDto[]>(`${this.baseUrl}/comment/dialogue/list/${dialogId}`);
  }

  getMessageCommentList(messageId: number): Observable<CommentDto[]> {
    return this.httpClient.get<CommentDto[]>(`${this.baseUrl}/comment/message/note/list/${messageId}`);
  }

  getMessageSuggestionList(messageId: number): Observable<CommentDto[]> {
    return this.httpClient.get<CommentDto[]>(`${this.baseUrl}/comment/message/suggestion/list/${messageId}`);
  }

  addComment(comment: CommentDto): Observable<CommentDto> {
    return this.httpClient.post<CommentDto>(`${this.baseUrl}/comment/dialogue/create`, comment);
  }

  addSuggestion(comment: CommentDto): Observable<CommentDto> {
    return this.httpClient.post<CommentDto>(`${this.baseUrl}/comment/message/suggestion/create`, comment);
  }

  updateComment(comment: CommentDto): Observable<CommentDto> {
    return this.httpClient.post<CommentDto>(`${this.baseUrl}/comment/update`, comment);
  }

  deleteComment(comment: CommentDto): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/comment/delete`, comment);
  }

  getCommentTypes(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/comment/types`);
  }

  exportDialogueToHubspot(request: ExportDialogueToHubspotRequest): Observable<StringResponse> {
    return this.httpClient.post<StringResponse>(`${this.baseUrl}/dialogue/export/hubspot`, request);
  }

  exportSignedFileToHubspot(request: ExportDialogueToHubspotRequest): Observable<StringResponse> {
    return this.httpClient.post<StringResponse>(`${this.baseUrl}/dialogue/export/hubspot/file`, request);
  }

  getXpeditionTypes(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/xpedition/types`);
  }

  getStoreList(typeId: number, search: string, limit: number, offset: number, sortProp: string, sortDir: string)
    : Observable<PagedData<DocumentStoreListDto>> {
    return this.httpClient.get<PagedData<DocumentStoreListDto>>(`${this.baseUrl}/store/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : '') + (typeId ? (`&typeId=` + typeId) : ''));
  }

  getStoreDashboard(): Observable<StoreDashboardDto> {
    return this.httpClient.get<StoreDashboardDto>(`${this.baseUrl}/store/dashboard`);
  }

  getArticleCollections(typeId: number, search: string, limit: number, offset: number, sortProp: string, sortDir: string)
    : Observable<PagedData<ArticleCollectionDto>> {
    return this.httpClient.get<PagedData<ArticleCollectionDto>>(`${this.baseUrl}/store/collection/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : '') + (typeId ? (`&typeId=` + typeId) : ''));
  }

  getStoreFullList(search: string = null): Observable<DocumentStoreListDto[]> {
    return this.httpClient.get<DocumentStoreListDto[]>(`${this.baseUrl}/store/full/list` +
      (search ? (`?search=` + encodeURI(search)) : ''));
  }

  getStoreCollections(search: string = null): Observable<DocumentStoreListDto[]> {
    return this.httpClient.get<DocumentStoreListDto[]>(`${this.baseUrl}/store/collections` +
      (search ? (`?search=` + encodeURI(search)) : ''));
  }

  exportStoreToZipAsync(storeId: number, search: string, limit: number, offset: number, sortProp: string, sortDir: string)
    : Observable<any> {
    const request = new StorePartRequest();
    request.storeId = storeId;
    request.search = search;
    request.limit = limit;
    request.offset = offset;
    request.sortProp = sortProp;
    request.sortDir = sortDir;
    return this.httpClient.post<any>(`${this.baseUrl}/store/export/zip`, request);
  }

  getStoreTypes(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/store/types`);
  }

  getStoreStatuses(): Observable<StoreStatusDto[]> {
    return this.httpClient.get<StoreStatusDto[]>(`${this.baseUrl}/store/statuses`);
  }

  getStorePartStatuses(): Observable<StoreStatusDto[]> {
    return this.httpClient.get<StoreStatusDto[]>(`${this.baseUrl}/store/statuses/part`);
  }

  getLoadTypes(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/store/loadtypes`);
  }

  getStore(id): Observable<DocumentStoreDto> {
    return this.httpClient.get<DocumentStoreDto>(`${this.baseUrl}/store/${id}`);
  }

  createStore(store: DocumentStoreDto): Observable<DocumentStoreDto> {
    return this.httpClient.post<DocumentStoreDto>(`${this.baseUrl}/store/create`, store);
  }

  updateStore(store: DocumentStoreDto): Observable<DocumentStoreDto> {
    return this.httpClient.post<DocumentStoreDto>(`${this.baseUrl}/store/update`, store);
  }

  updateStoreStatus(request: UpdateStatusRequest): Observable<DocumentStoreDto> {
    return this.httpClient.post<DocumentStoreDto>(`${this.baseUrl}/store/update/status`, request);
  }

  deleteStore(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/store/delete`, id);
  }

  clearStore(store: DocumentStoreDto): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/store/clear`, store);
  }

  copyStore(store: DocumentStoreDto): Observable<DocumentStoreDto> {
    return this.httpClient.post<DocumentStoreDto>(`${this.baseUrl}/store/copy`, store);
  }

  mergeStore(mainStoreId: number, mergedStoreId: number): Observable<DocumentStoreDto> {
    return this.httpClient.post<DocumentStoreDto>(`${this.baseUrl}/store/merge`, {mainStoreId, mergedStoreId});
  }

  getStorePartList(storeId: number, search: string, limit: number, offset: number, sortProp: string, sortDir: string)
    : Observable<PagedData<StorePartDto>> {
    return this.httpClient.get<PagedData<StorePartDto>>(`${this.baseUrl}/store/part/list/${storeId}?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getStorePart(id): Observable<StorePartDto> {
    return this.httpClient.get<StorePartDto>(`${this.baseUrl}/store/part/${id}`);
  }

  createStorePart(store: StorePartDto): Observable<StorePartDto> {
    return this.httpClient.post<StorePartDto>(`${this.baseUrl}/store/part/create`, store);
  }

  updateStorePart(store: StorePartDto): Observable<StorePartDto> {
    return this.httpClient.post<StorePartDto>(`${this.baseUrl}/store/part/update`, store);
  }

  deleteStorePart(store: StorePartDto): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/store/part/delete`, store);
  }

  deleteStoreParts(store: StorePartDto[]): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/store/parts/delete`, store);
  }

  uploadPdfToStore(fileBody: string, fileName: string): Observable<StringResponse> {
    return this.httpClient.post<StringResponse>(`${this.baseUrl}/store/upload/pdf`, {fileBody, fileName});
  }

  exportPdfToStore(pdfExportRequest: PdfExportRequest): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/store/export/pdf`, pdfExportRequest);
  }

  getTypeRoleSearchList(search: string, limit: number, offset: number,
                        sortProp: string, sortDir: string): Observable<PagedData<TypeRoleDto>> {
    return this.httpClient.get<PagedData<TypeRoleDto>>(`${this.baseUrl}/typerole/list?limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  deleteTypeRole(trId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/typerole/delete`, trId);
  }

  createTypeRole(typeRoleDto: TypeRoleDto): Observable<TypeRoleDto> {
    return this.httpClient.post<TypeRoleDto>(`${this.baseUrl}/typerole/create`, typeRoleDto);
  }

  updateTypeRole(typeRoleDto: TypeRoleDto): Observable<TypeRoleDto> {
    return this.httpClient.post<TypeRoleDto>(`${this.baseUrl}/typerole/update`, typeRoleDto);
  }

  getTypeRole(id): Observable<TypeRoleDto> {
    return this.httpClient.get<TypeRoleDto>(`${this.baseUrl}/typerole/` + id);
  }

  getLoadSettings(loadTypeId: number, storeId: number): Observable<LoadSettingsDto> {
    return this.httpClient.get<LoadSettingsDto>(`${this.baseUrl}/load-settings/${loadTypeId}/${storeId}`);
  }

  upsertLoadSettings(loadSittings: LoadSettingsDto): Observable<LoadSettingsDto> {
    return this.httpClient.post<LoadSettingsDto>(`${this.baseUrl}/load-settings/upsert`, loadSittings);
  }

  exportPdf(pdfExportRequest: PdfExportRequest): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/store/export/pdf`, pdfExportRequest);
  }

  addFromContent(addFromContentsRequest: AddFromContentsRequest): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/store/test/add/content`, addFromContentsRequest);
  }

  syncWithContent(storeId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/store/test/sync/content`, {storeId});
  }

  testRefresh(customerId: number, storeName: string): Observable<RefreshStoreResponse> {
    const storeObj: StoreObj = new StoreObj();
    storeObj.storeName = storeName;
    storeObj.customerId = customerId;
    return this.httpClient.post<RefreshStoreResponse>(`${this.baseUrl}/store/test/refresh`,
      new RefreshStoreRequest(storeObj));
  }

  testWeaviateRefresh(storeId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/store/test/weaviate/refresh`, {storeId});
  }

  testStatus(customerId: number, storeName: string): Observable<VectorStoreStatusResponse> {
    const storeObj: StoreObj = new StoreObj();
    storeObj.storeName = storeName;
    storeObj.customerId = customerId;
    return this.httpClient.post<VectorStoreStatusResponse>(`${this.baseUrl}/store/test/status`, new RefreshStoreRequest(storeObj));
  }

  vectorStoreList(): Observable<VectorStore[]> {
    return this.httpClient.get<VectorStore[]>(`${this.baseUrl}/store/vector/list`);
  }

  testSearch(customerId: number, storeName: string, searchText: string): Observable<GenerateTextContext> {
    const storeObj: StoreObj = new StoreObj();
    storeObj.storeName = storeName;
    storeObj.customerId = customerId;
    return this.httpClient.post<GenerateTextContext>(`${this.baseUrl}/store/test/search`, new SearchInStoreRequest(storeObj, searchText));
  }

  testGenerateFromDocs(customerId: number, storeName: string, text: string): Observable<GenerateTextResponse> {
    const storeObj: StoreObj = new StoreObj();
    storeObj.storeName = storeName;
    storeObj.customerId = customerId;
    return this.httpClient.post<GenerateTextResponse>(`${this.baseUrl}/store/test/generate`, new GenerateTextRequest(storeObj, text));
  }

  testGenerateText(text: string): Observable<GenerateTextResponse> {
    return this.httpClient.post<GenerateTextResponse>(`${this.baseUrl}/store/test/generate/text`, {text});
  }

  testGetPdfInfo(path: string): Observable<GetPdfInfoResponse> {
    return this.httpClient.post<GetPdfInfoResponse>(`${this.baseUrl}/store/test/pdf/info`, {path});
  }

  testReCreate(request: ReCreateRequest): Observable<ReCreateResponse> {
    return this.httpClient.post<ReCreateResponse>(`${this.baseUrl}/store/test/re/create`, request);
  }

  testReCheck(request: ReCheckRequest): Observable<ReCheckResponse> {
    return this.httpClient.post<ReCheckResponse>(`${this.baseUrl}/store/test/re/check`, request);
  }

  testExportWeb(request: ExportWebRequest): Observable<ExportWebResponse> {
    return this.httpClient.post<ExportWebResponse>(`${this.baseUrl}/store/test/export/web`, request);
  }

  testParseSite(path: string): Observable<ParseSiteResponse> {
    return this.httpClient.post<ParseSiteResponse>(`${this.baseUrl}/store/test/parse/sitemap`, {path});
  }

  testEvaluate(customerId: number, storeName: string, text: string, expectedAnswer: string): Observable<EvaluateStoreResponse> {
    const storeObj: StoreObj = new StoreObj();
    storeObj.storeName = storeName;
    storeObj.customerId = customerId;
    return this.httpClient.post<EvaluateStoreResponse>(`${this.baseUrl}/store/test/evaluate`,
      new EvaluateStoreRequest(storeObj, text, expectedAnswer));
  }

  getExperimentList(storeId: number, search: string, limit: number, offset: number, sortProp: string, sortDir: string)
    : Observable<PagedData<ExperimentListDto>> {
    return this.httpClient.get<PagedData<ExperimentListDto>>(`${this.baseUrl}/experiment/list/${storeId}?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  deleteExperiment(experimentId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/experiment/delete`, experimentId);
  }

  createExperiment(experimentDto: ExperimentDto): Observable<ExperimentDto> {
    return this.httpClient.post<ExperimentDto>(`${this.baseUrl}/experiment/create`, experimentDto);
  }

  updateExperiment(experimentDto: ExperimentDto): Observable<ExperimentDto> {
    return this.httpClient.post<ExperimentDto>(`${this.baseUrl}/experiment/update`, experimentDto);
  }

  runExperiment(storeId: number, storeName: string, datasetId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/experiment/run`, {datasetId, storeId, storeName});
  }

  getExperiment(id): Observable<ExperimentDto> {
    return this.httpClient.get<ExperimentDto>(`${this.baseUrl}/experiment/` + id);
  }

  getTestDatasets(): Observable<TestDatasetDto[]> {
    return this.httpClient.get<TestDatasetDto[]>(`${this.baseUrl}/testdataset/list/all`);
  }

  getTestDatasetList(customerId: number, search: string, limit: number, offset: number, sortProp: string, sortDir: string)
    : Observable<PagedData<TestDatasetDto>> {
    return this.httpClient.get<PagedData<TestDatasetDto>>(`${this.baseUrl}/testdataset/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  deleteTestDataset(datasetId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/testdataset/delete`, datasetId);
  }

  createTestDataset(testDatasetDto: TestDatasetDto): Observable<TestDatasetDto> {
    return this.httpClient.post<TestDatasetDto>(`${this.baseUrl}/testdataset/create`, testDatasetDto);
  }

  updateTestDataset(testDatasetDto: TestDatasetDto): Observable<TestDatasetDto> {
    return this.httpClient.post<TestDatasetDto>(`${this.baseUrl}/testdataset/update`, testDatasetDto);
  }

  getTestDataset(id): Observable<TestDatasetDto> {
    return this.httpClient.get<TestDatasetDto>(`${this.baseUrl}/testdataset/` + id);
  }

  getExperimentResultsList(experimentId: number, search: string, limit: number, offset: number, sortProp: string, sortDir: string)
    : Observable<PagedData<ExperimentResultDto>> {
    return this.httpClient.get<PagedData<ExperimentResultDto>>(`${this.baseUrl}/experiment/result/list/${experimentId}?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getExperimentResult(id): Observable<ExperimentResultDto> {
    return this.httpClient.get<ExperimentResultDto>(`${this.baseUrl}/experiment/result/` + id);
  }

  getDatasetRowAllList(datasetId: number): Observable<DatasetRowDto[]> {
    return this.httpClient.get<DatasetRowDto[]>(`${this.baseUrl}/testdataset/row/list/all/${datasetId}`);
  }

  getDatasetRowList(datasetId: number, search: string, limit: number, offset: number, sortProp: string, sortDir: string)
    : Observable<PagedData<DatasetRowDto>> {
    return this.httpClient.get<PagedData<DatasetRowDto>>(`${this.baseUrl}/testdataset/row/list/${datasetId}?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  deleteDatasetRow(datasetRowId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/testdataset/row/delete`, datasetRowId);
  }

  createDatasetRow(datasetRowDto: DatasetRowDto): Observable<DatasetRowDto> {
    return this.httpClient.post<DatasetRowDto>(`${this.baseUrl}/testdataset/row/create`, datasetRowDto);
  }

  updateDatasetRow(datasetRowDto: DatasetRowDto): Observable<DatasetRowDto> {
    return this.httpClient.post<DatasetRowDto>(`${this.baseUrl}/testdataset/row/update`, datasetRowDto);
  }

  getDatasetRow(id): Observable<DatasetRowDto> {
    return this.httpClient.get<DatasetRowDto>(`${this.baseUrl}/testdataset/row/` + id);
  }

  importDatasetRowCsv(datasetId: number, file: string, fileName: string) {
    return this.httpClient.post<any>(`${this.baseUrl}/testdataset/import/csv`, {datasetId, file, fileName});
  }

  exportCustomerAsync(customerId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/customer/export/yaml/async`, {customerId});
  }

  importCustomer(customerId: number, file: string, fileName: string) {
    return this.httpClient.post<any>(`${this.baseUrl}/customer/import/yaml/async`, {customerId, file, fileName});
  }

  deleteCustomerCascade(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/customer/delete/cascade`, id);
  }

  stopOperation(exchangeId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/customer/operation/stop`, exchangeId);
  }

  createInDialogue(botId: number, dialogName: string, alwaysCreate: boolean, lang: string): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/dialogue/create`, {botId, dialogName, alwaysCreate, lang});
  }

  createExerciseDialogue(request: CreateDialogueRequest): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/dialogue/create`, request);
  }

  deleteDialogueCascade(dialogId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/dialogue/delete/cascade`, dialogId);
  }

  dialogueToArchive(archiveProcedure: ArchiveProcedure, dialogId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/dialogue/to/archive`, {archiveProcedure, dialogId});
  }

  dialogueFromArchive(dialogId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/dialogue/from/archive`, dialogId);
  }

  clearArchive(dialogId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/dialogue/clear/archive`, dialogId);
  }

  getArticleCategories(): Observable<ArticleCategoryDto[]> {
    return this.httpClient.get<ArticleCategoryDto[]>(`${this.baseUrl}/article/categories`);
  }

  getArticles(customerId: number, categoryIds: number[], storeIds: number[], dateB: string, dateE: string, hasTitle: FilterValueMode,
              hasDoi: FilterValueMode, hasCategories: FilterValueMode, hasStories: FilterValueMode, hasJson: FilterValueMode,
              hasSections: FilterValueMode, hasProcessedLlm: FilterValueMode, langMode: FilterValueLangMode, published: FilterBoolean,
              mode: FilterArticleMode, auId: number, search: string, limit: number, offset: number, sortProp: string, sortDir: string)
    : Observable<PagedData<ArticleDto>> {
    return this.httpClient.get<PagedData<ArticleDto>>(`${this.baseUrl}/article/list?customerId=${customerId}` +
      (categoryIds ? `&categoryIds=${categoryIds}` : '') +
      (storeIds ? `&storeIds=${storeIds}` : '') +
      (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : '') +
      (hasTitle ? `&hasTitle=${hasTitle}` : '') +
      (hasDoi ? `&hasDoi=${hasDoi}` : '') +
      (hasCategories ? `&hasCategories=${hasCategories}` : '') +
      (hasStories ? `&hasStories=${hasStories}` : '') +
      (hasJson ? `&hasJson=${hasJson}` : '') +
      (hasSections ? `&hasSections=${hasSections}` : '') +
      (hasProcessedLlm ? `&hasProcessedLlm=${hasProcessedLlm}` : '') +
      (langMode ? `&langMode=${langMode}` : '') +
      (published ? `&published=${published}` : '') +
      (mode ? `&mode=${mode}` : '') +
      (auId ? `&auId=${auId}` : '') +
      `&limit=${limit}&offset=${offset}` +
      (sortProp ? (`&sortProp=${sortProp}&sortDir=${sortDir}`) : '') +
      (search ? `&search=${encodeURI(search)}` : ''));
  }

  getArticleIdsList(customerId: number, categoryIds: number[], storeIds: number[], dateB: string, dateE: string, hasTitle: FilterValueMode,
                    hasDoi: FilterValueMode, hasCategories: FilterValueMode, hasStories: FilterValueMode, hasJson: FilterValueMode,
                    hasSections: FilterValueMode, hasProcessedLlm: FilterValueMode, langMode: FilterValueLangMode, published: FilterBoolean,
                    mode: FilterArticleMode, auId: number, search: string, sortProp: string, sortDir: string): Observable<number[]> {
    return this.httpClient.get<number[]>(`${this.baseUrl}/article/list/ids?customerId=${customerId}` +
      (categoryIds ? `&categoryIds=${categoryIds}` : '') +
      (storeIds ? `&storeIds=${storeIds}` : '') +
      (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : '') +
      (hasTitle ? `&hasTitle=${hasTitle}` : '') +
      (hasDoi ? `&hasDoi=${hasDoi}` : '') +
      (hasCategories ? `&hasCategories=${hasCategories}` : '') +
      (hasStories ? `&hasStories=${hasStories}` : '') +
      (hasJson ? `&hasJson=${hasJson}` : '') +
      (hasSections ? `&hasSections=${hasSections}` : '') +
      (hasProcessedLlm ? `&hasProcessedLlm=${hasProcessedLlm}` : '') +
      (langMode ? `&langMode=${langMode}` : '') +
      (published ? `&published=${published}` : '') +
      (mode ? `&mode=${mode}` : '') +
      (auId ? `&auId=${auId}` : '') +
      (sortProp ? (`&sortProp=${sortProp}&sortDir=${sortDir}`) : '') +
      (search ? `&search=${encodeURI(search)}` : ''));
  }

  uploadPdfToArticle(exchangeId: number,
                     fileBody: string,
                     fileName: string,
                     updateExists: boolean,
                     translateJson: boolean,
                     detectLanguage: boolean,
                     crossRefConsolidation: boolean,
                     categoryIds: number[],
                     storeId: number): Observable<ArticleDto> {
    return this.httpClient.post<ArticleDto>(`${this.baseUrl}/article/upload/pdf`,
      {exchangeId, fileBody, fileName, updateExists, translateJson, detectLanguage, crossRefConsolidation, categoryIds, storeId});
  }

  uploadXmlToArticle(exchangeId: number,
                     fileBody: string,
                     fileName: string,
                     updateExists: boolean,
                     translateJson: boolean,
                     detectLanguage: boolean): Observable<ArticleDto> {
    return this.httpClient.post<ArticleDto>(`${this.baseUrl}/article/upload/xml`,
      {exchangeId, fileBody, fileName, updateExists, translateJson, detectLanguage});
  }

  getArticleById(id: number): Observable<ArticleDto> {
    return this.httpClient.get<ArticleDto>(`${this.baseUrl}/article/` + id);
  }

  updateArticle(article: ArticleDto): Observable<ArticleDto> {
    return this.httpClient.post<ArticleDto>(`${this.baseUrl}/article/update`, article);
  }

  updateArticleJson(article: ArticleDto): Observable<ArticleDto> {
    return this.httpClient.post<ArticleDto>(`${this.baseUrl}/article/update/json`, article);
  }

  extractLlm(articleId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/article/extract/llm`, {articleId});
  }

  extractLlmAsync(articleIds: number[]): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/article/extract/llm/async`, {articleIds});
  }

  articlesTranslate(ids: number[]): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/article/translate/async`, ids);
  }

  articleTranslate(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/article/translate`, id);
  }

  articlesDetectTranslate(ids: number[]): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/article/detect/translate/async`, ids);
  }

  articleDetectTranslate(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/article/detect/translate`, id);
  }

  articlesDetect(ids: number[]): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/article/detect/async`, ids);
  }

  articleDetect(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/article/detect`, id);
  }

  articleRecreateJson(ids: number[], translateJson: boolean, detectLanguage: boolean): Observable<ArticleDto> {
    return this.httpClient.post<ArticleDto>(`${this.baseUrl}/article/recreate/json`, {ids, translateJson, detectLanguage});
  }

  getCategoriesByArticleId(articleId: number): Observable<ArticleCategoryDto[]> {
    return this.httpClient.get<ArticleCategoryDto[]>(`${this.baseUrl}/article/categories/` + articleId);
  }

  updateArticleCategories(articleIds: number[], categories: ArticleCategoryDto[]): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/article/categories/update`, {articleIds, categories});
  }

  addToStore(storeId: number, articleIds: number[]): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/article/store/add`, {storeId, articleIds});
  }

  removeFromStore(storeId: number, articleIds: number[]): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/article/store/remove`, {storeId, articleIds});
  }

  deleteArticle(ids: number[]): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/article/delete`, ids);
  }

  publishArticle(ids: number[]): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/article/publish`, ids);
  }

  unpublishArticle(ids: number[]): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/article/unpublish`, ids);
  }

  collectionRefresh(storeId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/store/collection/refresh`, storeId);
  }

  collectionClear(storeId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/store/collection/clear`, storeId);
  }

  collectionRemove(storeId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/store/collection/delete`, storeId);
  }

  collectionUpdate(store: DocumentStoreDto): Observable<DocumentStoreDto> {
    return this.httpClient.post<DocumentStoreDto>(`${this.baseUrl}/store/collection/update`, store);
  }

  collectionMerge(mainStoreId: number, mergedStoreId: number): Observable<DocumentStoreDto> {
    return this.httpClient.post<DocumentStoreDto>(`${this.baseUrl}/store/collection/merge`, {mainStoreId, mergedStoreId});
  }

  resumePublish(exchangeId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/article/publish/resume`, exchangeId);
  }

  resumeUnpublish(exchangeId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/article/unpublish/resume`, exchangeId);
  }

  resumeCollection(exchangeId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/store/collection/resume`, exchangeId);
  }

  createExchange(exchangeDto: ExchangeDto): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/exchange/create`, exchangeDto);
  }

  closeExchange(exchangeId: number, toLoad: number, loaded: number, error: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/exchange/close`, {exchangeId, toLoad, loaded, error});
  }

  resumeUpdateArticles(exchangeId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/article/resume`, exchangeId);
  }

  getArticleCategoryList(search: string, limit: number, offset: number,
                         sortProp: string, sortDir: string): Observable<PagedData<ArticleCategoryDto>> {
    return this.httpClient.get<PagedData<ArticleCategoryDto>>(`${this.baseUrl}/article/category/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  deleteArticleCategory(acatId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/article/category/delete`, acatId);
  }

  createArticleCategory(categoryDto: ArticleCategoryDto): Observable<any> {
    return this.httpClient.post<CategoryDto>(`${this.baseUrl}/article/category/create`, categoryDto);
  }

  updateArticleCategory(categoryDto: ArticleCategoryDto): Observable<any> {
    return this.httpClient.post<CategoryDto>(`${this.baseUrl}/article/category/update`, categoryDto);
  }

  getArticleCategory(id: number): Observable<CategoryDto> {
    return this.httpClient.get<CategoryDto>(`${this.baseUrl}/article/category/` + id);
  }

  getLocations(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/content/locations`);
  }

  getLocationList(search: string, limit: number, offset: number,
                  sortProp: string, sortDir: string): Observable<PagedData<LocationDto>> {
    return this.httpClient.get<PagedData<LocationDto>>(`${this.baseUrl}/location/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  deleteLocation(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/location/delete`, id);
  }

  createLocation(locationDto: LocationDto): Observable<any> {
    return this.httpClient.post<LocationDto>(`${this.baseUrl}/location/create`, locationDto);
  }

  updateLocation(locationDto: LocationDto): Observable<any> {
    return this.httpClient.post<LocationDto>(`${this.baseUrl}/location/update`, locationDto);
  }

  getLocation(id): Observable<LocationDto> {
    return this.httpClient.get<LocationDto>(`${this.baseUrl}/location/` + id);
  }

  getArticleExchangeList(exchangeId: number, search: string, limit: number, offset: number,
                         sortProp: string, sortDir: string): Observable<PagedData<ArticleExchangeDto>> {
    return this.httpClient.get<PagedData<ArticleExchangeDto>>(`${this.baseUrl}/article/exchange/list/${exchangeId}?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getArticleExchangeListByArticleId(articleId: number, search: string, limit: number, offset: number,
                                    sortProp: string, sortDir: string): Observable<PagedData<ArticleExchangeDto>> {
    return this.httpClient.get<PagedData<ArticleExchangeDto>>(`${this.baseUrl}/article/exchange/list/article/${articleId}?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getRaDialogues(articleId: number, search: string, limit: number, offset: number, sortProp: string, sortDir: string)
    : Observable<PagedData<RaDialoguesDto>> {
    return this.httpClient.get<PagedData<RaDialoguesDto>>(`${this.baseUrl}/article/ra/list?limit=` + limit +
      (articleId ? (`&articleId=` + articleId) : '') + `&offset=` + offset +
      (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getRaArticles(dialogId: number, type: RaGroupType, search: string, limit: number, offset: number, sortProp: string,
                sortDir: string): Observable<PagedData<RaArticlesDto>> {
    return this.httpClient.get<PagedData<RaArticlesDto>>(`${this.baseUrl}/article/ra/article/list?limit=` + limit +
      (dialogId ? (`&dialogId=` + dialogId) : '') + (type ? (`&type=` + type) : '') +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getReviewDialogueList(search: string, limit: number, offset: number, sortProp: string, sortDir: string):
    Observable<PagedData<ReviewDialogueListDto>> {
    return this.httpClient.get<PagedData<ReviewDialogueListDto>>(`${this.baseUrl}/article/ra/dialogue/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getRaStatuses(): Observable<StringResponse[]> {
    return this.httpClient.get<StringResponse[]>(`${this.baseUrl}/article/ra/statuses`);
  }

  addToCollection(dialogId: number, storeId: number, statusList: StringResponse[]): Observable<any> {
    const statuses = statusList.map(s => s.value);
    return this.httpClient.post<LocationDto>(`${this.baseUrl}/article/ra/add/collection`, {dialogId, storeId, statuses});
  }

  getArticlePdf(articleId: number): Observable<ExportResult> {
    return this.httpClient.get<ExportResult>(`${this.baseUrl}/article/download/pdf/${articleId}`);
  }

  getOrganizationList(search: string, limit: number, offset: number, sortProp: string, sortDir: string):
    Observable<PagedData<OrganizationListDto>> {
    return this.httpClient.get<PagedData<OrganizationListDto>>(`${this.baseUrl}/organizations/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getOrganizationCount(): Observable<NumberResponse> {
    return this.httpClient.get<NumberResponse>(`${this.baseUrl}/organizations/count`);
  }

  getServiceCount(): Observable<NumberResponse> {
    return this.httpClient.get<NumberResponse>(`${this.baseUrl}/service/count`);
  }

  getDashboardData(): Observable<CmServiceDashboardDto> {
    return this.httpClient.get<CmServiceDashboardDto>(`${this.baseUrl}/service/dashboard`);
  }

  getOrganization(id): Observable<OrganizationDto> {
    return this.httpClient.get<OrganizationDto>(`${this.baseUrl}/organizations/` + id);
  }

  createOrganization(organizationDto: OrganizationDto): Observable<OrganizationDto> {
    return this.httpClient.post<OrganizationDto>(`${this.baseUrl}/organizations/create`, organizationDto);
  }

  updateOrganization(organizationDto: OrganizationDto): Observable<OrganizationDto> {
    return this.httpClient.post<OrganizationDto>(`${this.baseUrl}/organizations/update`, organizationDto);
  }

  deleteOrganization(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/organizations/delete`, id);
  }

  getServiceList(orgId: number, locationId: number, ageIds: number[], countyIds: number[], langIds: number[], ethnicityIds: number[],
                 insuranceIds: number[], disorderIds: number[], typeTreatmentIds: number[], subcategoryIds: number[],
                 hasCalAccepts: FilterBoolean, hasInsuranceAccepts: FilterBoolean, hasCashOnly: FilterBoolean,
                 hasPublished: FilterBoolean, hasReviewed: FilterBoolean, search: string, limit: number, offset: number,
                 sortProp: string, sortDir: string):
    Observable<PagedData<ServiceListDto>> {
    return this.httpClient.get<PagedData<ServiceListDto>>(`${this.baseUrl}/service/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : '') + (orgId ? (`&orgId=` + orgId) : '') +
      (locationId ? `&locationId=${locationId}` : '') +
      (ageIds && ageIds.length > 0 ? `&ageIds=${ageIds}` : '') +
      (countyIds && countyIds.length > 0 ? `&countyIds=${countyIds}` : '') +
      (langIds && langIds.length > 0 ? `&langIds=${langIds}` : '') +
      (ethnicityIds && ethnicityIds.length > 0 ? `&ethnicityIds=${ethnicityIds}` : '') +
      (insuranceIds && insuranceIds.length > 0 ? `&insuranceIds=${insuranceIds}` : '') +
      (disorderIds && disorderIds.length > 0 ? `&disorderIds=${disorderIds}` : '') +
      (typeTreatmentIds && typeTreatmentIds.length > 0 ? `&typeTreatmentIds=${typeTreatmentIds}` : '') +
      (subcategoryIds && subcategoryIds.length > 0 ? `&subcategoryIds=${subcategoryIds}` : '') +
      (hasCalAccepts ? `&hasCalAccepts=${hasCalAccepts}` : '') +
      (hasInsuranceAccepts ? `&hasInsuranceAccepts=${hasInsuranceAccepts}` : '') +
      (hasCashOnly ? `&hasCashOnly=${hasCashOnly}` : '') +
      (hasPublished ? `&hasPublished=${hasPublished}` : '') +
      (hasReviewed ? `&hasReviewed=${hasReviewed}` : ''));
  }

  getServiceReport(orgId: number, locationId: number, ageIds: number[], countyIds: number[], langIds: number[], ethnicityIds: number[],
                   insuranceIds: number[], disorderIds: number[], typeTreatmentIds: number[], subcategoryIds: number[],
                   hasCalAccepts: FilterBoolean, hasInsuranceAccepts: FilterBoolean, hasCashOnly: FilterBoolean, hasPublished: FilterBoolean,
                   hasReviewed: FilterBoolean, search: string):
    Observable<ServiceReportDto[]> {
    return this.httpClient.get<ServiceReportDto[]>(`${this.baseUrl}/service/report/list?offset=0` +
      (search ? (`&search=` + encodeURI(search)) : '') + (orgId ? (`&orgId=` + orgId) : '') +
      (locationId ? `&locationId=${locationId}` : '') +
      (ageIds && ageIds.length > 0 ? `&ageIds=${ageIds}` : '') +
      (countyIds && countyIds.length > 0 ? `&countyIds=${countyIds}` : '') +
      (langIds && langIds.length > 0 ? `&langIds=${langIds}` : '') +
      (ethnicityIds && ethnicityIds.length > 0 ? `&ethnicityIds=${ethnicityIds}` : '') +
      (insuranceIds && insuranceIds.length > 0 ? `&insuranceIds=${insuranceIds}` : '') +
      (disorderIds && disorderIds.length > 0 ? `&disorderIds=${disorderIds}` : '') +
      (typeTreatmentIds && typeTreatmentIds.length > 0 ? `&typeTreatmentIds=${typeTreatmentIds}` : '') +
      (subcategoryIds && subcategoryIds.length > 0 ? `&subcategoryIds=${subcategoryIds}` : '') +
      (hasCalAccepts ? `&hasCalAccepts=${hasCalAccepts}` : '') +
      (hasInsuranceAccepts ? `&hasInsuranceAccepts=${hasInsuranceAccepts}` : '') +
      (hasCashOnly ? `&hasCashOnly=${hasCashOnly}` : '') +
      (hasPublished ? `&hasPublished=${hasPublished}` : '') +
      (hasReviewed ? `&hasReviewed=${hasReviewed}` : ''));
  }

  getService(id): Observable<ServiceDto> {
    return this.httpClient.get<ServiceDto>(`${this.baseUrl}/service/` + id);
  }

  createService(serviceDto: ServiceDto): Observable<ServiceDto> {
    return this.httpClient.post<ServiceDto>(`${this.baseUrl}/service/create`, serviceDto);
  }

  updateService(serviceDto: ServiceDto): Observable<ServiceDto> {
    return this.httpClient.post<ServiceDto>(`${this.baseUrl}/service/update`, serviceDto);
  }

  deleteService(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/service/delete`, id);
  }

  generateHtmlForService(id: number): Observable<ServiceDto> {
    return this.httpClient.post<ServiceDto>(`${this.baseUrl}/service/generate/html`, id);
  }

  getDisorderList(search: string, limit: number, offset: number, sortProp: string, sortDir: string):
    Observable<PagedData<DisorderDto>> {
    return this.httpClient.get<PagedData<DisorderDto>>(`${this.baseUrl}/cm/disorder/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getDisorderAllList(): Observable<DisorderDto[]> {
    return this.httpClient.get<DisorderDto[]>(`${this.baseUrl}/cm/disorder/all/list`);
  }

  getDisorder(id): Observable<DisorderDto> {
    return this.httpClient.get<DisorderDto>(`${this.baseUrl}/cm/disorder/` + id);
  }

  createDisorder(disorderDto: DisorderDto): Observable<DisorderDto> {
    return this.httpClient.post<DisorderDto>(`${this.baseUrl}/cm/disorder/create`, disorderDto);
  }

  updateDisorder(disorderDto: DisorderDto): Observable<DisorderDto> {
    return this.httpClient.post<DisorderDto>(`${this.baseUrl}/cm/disorder/update`, disorderDto);
  }

  deleteDisorder(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/cm/disorder/delete`, id);
  }

  getTypeTreatmentsList(search: string, limit: number, offset: number, sortProp: string, sortDir: string):
    Observable<PagedData<TypeTreatmentsDto>> {
    return this.httpClient.get<PagedData<TypeTreatmentsDto>>(`${this.baseUrl}/cm/treatments/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getTypeTreatmentsAllList(): Observable<TypeTreatmentsDto[]> {
    return this.httpClient.get<TypeTreatmentsDto[]>(`${this.baseUrl}/cm/treatments/all/list`);
  }

  getTypeTreatments(id): Observable<TypeTreatmentsDto> {
    return this.httpClient.get<TypeTreatmentsDto>(`${this.baseUrl}/cm/treatments/` + id);
  }

  createTypeTreatments(treatmentsDto: TypeTreatmentsDto): Observable<TypeTreatmentsDto> {
    return this.httpClient.post<TypeTreatmentsDto>(`${this.baseUrl}/cm/treatments/create`, treatmentsDto);
  }

  updateTypeTreatments(treatmentsDto: TypeTreatmentsDto): Observable<TypeTreatmentsDto> {
    return this.httpClient.post<TypeTreatmentsDto>(`${this.baseUrl}/cm/treatments/update`, treatmentsDto);
  }

  deleteTypeTreatments(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/cm/treatments/delete`, id);
  }

  getInsuranceList(search: string, limit: number, offset: number, sortProp: string, sortDir: string):
    Observable<PagedData<InsuranceDto>> {
    return this.httpClient.get<PagedData<InsuranceDto>>(`${this.baseUrl}/cm/insurance/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getInsuranceAllList(types: string[]): Observable<InsuranceDto[]> {
    return this.httpClient.get<InsuranceDto[]>(`${this.baseUrl}/cm/insurance/all/list/` + types.join(','));
  }

  getInsurance(id): Observable<InsuranceDto> {
    return this.httpClient.get<InsuranceDto>(`${this.baseUrl}/cm/insurance/` + id);
  }

  createInsurance(insuranceDto: InsuranceDto): Observable<InsuranceDto> {
    return this.httpClient.post<InsuranceDto>(`${this.baseUrl}/cm/insurance/create`, insuranceDto);
  }

  updateInsurance(insuranceDto: InsuranceDto): Observable<InsuranceDto> {
    return this.httpClient.post<InsuranceDto>(`${this.baseUrl}/cm/insurance/update`, insuranceDto);
  }

  deleteInsurance(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/cm/insurance/delete`, id);
  }

  getCmLanguageList(search: string, limit: number, offset: number):
    Observable<PagedData<CmLanguageDto>> {
    return this.httpClient.get<PagedData<CmLanguageDto>>(`${this.baseUrl}/cm/language/list?limit=` + limit +
      `&offset=` + offset + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getCmLanguageAllList(): Observable<CmLanguageDto[]> {
    return this.httpClient.get<CmLanguageDto[]>(`${this.baseUrl}/cm/language/all/list`);
  }

  getCmLanguage(id): Observable<CmLanguageDto> {
    return this.httpClient.get<CmLanguageDto>(`${this.baseUrl}/cm/language/` + id);
  }

  createCmLanguage(dictionary: CmLanguageDto): Observable<CmLanguageDto> {
    return this.httpClient.post<CmLanguageDto>(`${this.baseUrl}/cm/language/create`, dictionary);
  }

  updateCmLanguage(dictionary: CmLanguageDto): Observable<CmLanguageDto> {
    return this.httpClient.post<CmLanguageDto>(`${this.baseUrl}/cm/language/update`, dictionary);
  }

  deleteCmLanguage(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/cm/language/delete`, id);
  }

  getCmEthnicityList(search: string, limit: number, offset: number, sortProp: string, sortDir: string):
    Observable<PagedData<Dictionary>> {
    return this.httpClient.get<PagedData<Dictionary>>(`${this.baseUrl}/cm/ethnicity/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getCmEthnicityAllList(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/cm/ethnicity/all/list`);
  }

  getCmEthnicity(id): Observable<Dictionary> {
    return this.httpClient.get<Dictionary>(`${this.baseUrl}/cm/ethnicity/` + id);
  }

  createCmEthnicity(dictionary: Dictionary): Observable<Dictionary> {
    return this.httpClient.post<Dictionary>(`${this.baseUrl}/cm/ethnicity/create`, dictionary);
  }

  updateCmEthnicity(dictionary: Dictionary): Observable<Dictionary> {
    return this.httpClient.post<Dictionary>(`${this.baseUrl}/cm/ethnicity/update`, dictionary);
  }

  deleteCmEthnicity(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/cm/ethnicity/delete`, id);
  }

  getCmAgeList(search: string, limit: number, offset: number):
    Observable<PagedData<CmAgeDto>> {
    return this.httpClient.get<PagedData<CmAgeDto>>(`${this.baseUrl}/cm/age/list?limit=` + limit +
      `&offset=` + offset + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getCmAgeAllList(): Observable<CmAgeDto[]> {
    return this.httpClient.get<CmAgeDto[]>(`${this.baseUrl}/cm/age/all/list`);
  }

  getCmAge(id): Observable<CmAgeDto> {
    return this.httpClient.get<CmAgeDto>(`${this.baseUrl}/cm/age/` + id);
  }

  createCmAge(dictionary: CmAgeDto): Observable<CmAgeDto> {
    return this.httpClient.post<CmAgeDto>(`${this.baseUrl}/cm/age/create`, dictionary);
  }

  updateCmAge(dictionary: CmAgeDto): Observable<CmAgeDto> {
    return this.httpClient.post<CmAgeDto>(`${this.baseUrl}/cm/age/update`, dictionary);
  }

  deleteCmAge(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/cm/age/delete`, id);
  }

  changeCmAgeOrder(id: number, type: ChangeOrderType): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/cm/age/change/order`, {id, type});
  }

  getCmCategoryList(search: string, limit: number, offset: number, sortProp: string, sortDir: string):
    Observable<PagedData<CmCategoryDto>> {
    return this.httpClient.get<PagedData<CmCategoryDto>>(`${this.baseUrl}/cm/category/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getCmCategoryAllList(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/cm/category/all/list`);
  }

  getCmCategory(id): Observable<CmCategoryDto> {
    return this.httpClient.get<CmCategoryDto>(`${this.baseUrl}/cm/category/` + id);
  }

  createCmCategory(dictionary: CmCategoryDto): Observable<CmCategoryDto> {
    return this.httpClient.post<CmCategoryDto>(`${this.baseUrl}/cm/category/create`, dictionary);
  }

  updateCmCategory(dictionary: CmCategoryDto): Observable<CmCategoryDto> {
    return this.httpClient.post<CmCategoryDto>(`${this.baseUrl}/cm/category/update`, dictionary);
  }

  deleteCmCategory(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/cm/category/delete`, id);
  }

  getSubcategoryList(id: number): Observable<SubcategoryDto[]> {
    return this.httpClient.get<SubcategoryDto[]>(`${this.baseUrl}/cm/category/sub/list/` + id);
  }

  getSubcategoryAllList(): Observable<SubcategoryDto[]> {
    return this.httpClient.get<SubcategoryDto[]>(`${this.baseUrl}/cm/category/sub/all/list`);
  }

  getSubcategory(id): Observable<SubcategoryDto> {
    return this.httpClient.get<SubcategoryDto>(`${this.baseUrl}/cm/category/sub/` + id);
  }

  createSubcategory(dictionary: SubcategoryDto): Observable<SubcategoryDto> {
    return this.httpClient.post<SubcategoryDto>(`${this.baseUrl}/cm/category/sub/create`, dictionary);
  }

  updateSubcategory(dictionary: SubcategoryDto): Observable<SubcategoryDto> {
    return this.httpClient.post<SubcategoryDto>(`${this.baseUrl}/cm/category/sub/update`, dictionary);
  }

  deleteSubcategory(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/cm/category/sub/delete`, id);
  }

  getCmLocationList(orgId: number, search: string, limit: number, offset: number, sortProp: string, sortDir: string):
    Observable<PagedData<CmLocationDto>> {
    return this.httpClient.get<PagedData<CmLocationDto>>(`${this.baseUrl}/cm/location/list?orgId=` + orgId + `&limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getCmLocation(id): Observable<CmLocationDto> {
    return this.httpClient.get<CmLocationDto>(`${this.baseUrl}/cm/location/` + id);
  }

  createCmLocation(locationDto: CmLocationDto): Observable<CmLocationDto> {
    return this.httpClient.post<CmLocationDto>(`${this.baseUrl}/cm/location/create`, locationDto);
  }

  updateCmLocation(locationDto: CmLocationDto): Observable<CmLocationDto> {
    return this.httpClient.post<CmLocationDto>(`${this.baseUrl}/cm/location/update`, locationDto);
  }

  deleteCmLocation(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/cm/location/delete`, id);
  }

  getCmLocationSrvList(srvId: number, search: string, limit: number, offset: number, sortProp: string, sortDir: string):
    Observable<PagedData<CmLocationServiceDto>> {
    return this.httpClient.get<PagedData<CmLocationServiceDto>>(`${this.baseUrl}/cm/location/srv/list?srvId=` + srvId +
      `&limit=` + limit + `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getCmLocationSrvAllList(srvId: number): Observable<CmLocationServiceDto[]> {
    return this.httpClient.get<CmLocationServiceDto[]>(`${this.baseUrl}/cm/location/srv/all/list/` + srvId);
  }

  getCmLocationOrgList(orgId: number): Observable<CmLocationDto[]> {
    return this.httpClient.get<CmLocationDto[]>(`${this.baseUrl}/cm/location/org/list/` + orgId);
  }

  getCmLocationSrv(id): Observable<CmLocationServiceDto> {
    return this.httpClient.get<CmLocationServiceDto>(`${this.baseUrl}/cm/location/srv/` + id);
  }

  createCmLocationSrv(srvId: number, locationId: number, countyIds: number[]): Observable<CmLocationServiceDto> {
    return this.httpClient.post<CmLocationServiceDto>(`${this.baseUrl}/cm/location/srv/create`, {srvId, locationId, countyIds});
  }

  updateCmLocationSrv(locationDto: CmLocationServiceDto): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/cm/location/srv/update`, locationDto);
  }

  deleteCmLocationSrv(locationDto: CmLocationServiceDto): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/cm/location/srv/delete`, locationDto);
  }

  getCmCountyAllList(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/cm/county/all/list`);
  }

  getCmCollaboratorList(search: string, limit: number, offset: number, sortProp: string, sortDir: string):
    Observable<PagedData<CmCollaboratorDto>> {
    return this.httpClient.get<PagedData<CmCollaboratorDto>>(`${this.baseUrl}/cm/collaborator/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getCmCollaborator(id): Observable<CmCollaboratorDto> {
    return this.httpClient.get<CmCollaboratorDto>(`${this.baseUrl}/cm/collaborator/` + id);
  }

  createCmCollaborator(collaborator: CmCollaboratorDto): Observable<CmCollaboratorDto> {
    return this.httpClient.post<CmCollaboratorDto>(`${this.baseUrl}/cm/collaborator/create`, collaborator);
  }

  updateCmCollaborator(collaborator: CmCollaboratorDto): Observable<CmCollaboratorDto> {
    return this.httpClient.post<CmCollaboratorDto>(`${this.baseUrl}/cm/collaborator/update`, collaborator);
  }

  deleteCmCollaborator(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/cm/collaborator/delete`, id);
  }

  getCollaboratorAllList(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/cm/collaborator/all/list`);
  }

  getCollaboratorOrgList(orgId: number): Observable<CmCollaboratorOrgDto[]> {
    return this.httpClient.get<CmCollaboratorOrgDto[]>(`${this.baseUrl}/cm/collaborator/org/list/` + orgId);
  }

  getCollaboratorOrg(id): Observable<CmCollaboratorOrgDto> {
    return this.httpClient.get<CmCollaboratorOrgDto>(`${this.baseUrl}/cm/collaborator/org/` + id);
  }

  createCollaboratorOrg(collaboratorOrgDto: CmCollaboratorOrgDto): Observable<CmCollaboratorOrgDto> {
    return this.httpClient.post<CmCollaboratorOrgDto>(`${this.baseUrl}/cm/collaborator/org/create`, collaboratorOrgDto);
  }

  updateCollaboratorOrg(collaboratorOrgDto: CmCollaboratorOrgDto): Observable<CmCollaboratorOrgDto> {
    return this.httpClient.post<CmCollaboratorOrgDto>(`${this.baseUrl}/cm/collaborator/org/update`, collaboratorOrgDto);
  }

  deleteCollaboratorOrg(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/cm/collaborator/org/delete`, id);
  }

  getContactPersonList(orgId: number): Observable<CmContactPersonDto[]> {
    return this.httpClient.get<CmContactPersonDto[]>(`${this.baseUrl}/cm/contactperson/list/` + orgId);
  }

  getContactPerson(id): Observable<CmContactPersonDto> {
    return this.httpClient.get<CmContactPersonDto>(`${this.baseUrl}/cm/contactperson/` + id);
  }

  createContactPerson(contactPersonDto: CmContactPersonDto): Observable<CmContactPersonDto> {
    return this.httpClient.post<CmContactPersonDto>(`${this.baseUrl}/cm/contactperson/create`, contactPersonDto);
  }

  updateContactPerson(contactPersonDto: CmContactPersonDto): Observable<CmContactPersonDto> {
    return this.httpClient.post<CmContactPersonDto>(`${this.baseUrl}/cm/contactperson/update`, contactPersonDto);
  }

  deleteContactPerson(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/cm/contactperson/delete`, id);
  }

  getCmCountyList(search: string, limit: number, offset: number, sortProp: string, sortDir: string):
    Observable<PagedData<CmCountyDto>> {
    return this.httpClient.get<PagedData<CmCountyDto>>(`${this.baseUrl}/cm/county/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getCmCounty(id): Observable<CmCountyDto> {
    return this.httpClient.get<CmCountyDto>(`${this.baseUrl}/cm/county/` + id);
  }

  createCmCounty(dictionary: CmCountyDto): Observable<CmCountyDto> {
    return this.httpClient.post<CmCountyDto>(`${this.baseUrl}/cm/county/create`, dictionary);
  }

  updateCmCounty(dictionary: CmCountyDto): Observable<CmCountyDto> {
    return this.httpClient.post<CmCountyDto>(`${this.baseUrl}/cm/county/update`, dictionary);
  }

  deleteCmCounty(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/cm/county/delete`, id);
  }

  publishResources(ids: number[]): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/service/publish/async`, ids);
  }

  unpublishResources(ids: number[]): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/service/unpublish/async`, ids);
  }

  publishResource(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/service/publish`, id);
  }

  unpublishResource(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/service/unpublish`, id);
  }

  getCmRegionList(search: string, limit: number, offset: number, sortProp: string, sortDir: string):
    Observable<PagedData<CMRegionDto>> {
    return this.httpClient.get<PagedData<CMRegionDto>>(`${this.baseUrl}/cm/region/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getCmRegionAllList(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/cm/region/all/list`);
  }

  getCmRegion(id): Observable<CMRegionDto> {
    return this.httpClient.get<CMRegionDto>(`${this.baseUrl}/cm/region/` + id);
  }

  createCmRegion(dictionary: CMRegionDto): Observable<CMRegionDto> {
    return this.httpClient.post<CMRegionDto>(`${this.baseUrl}/cm/region/create`, dictionary);
  }

  updateCmRegion(dictionary: CMRegionDto): Observable<CMRegionDto> {
    return this.httpClient.post<CMRegionDto>(`${this.baseUrl}/cm/region/update`, dictionary);
  }

  deleteCmRegion(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/cm/region/delete`, id);
  }

  getExerciseCount(): Observable<NumberResponse> {
    return this.httpClient.get<NumberResponse>(`${this.baseUrl}/exercise/count`);
  }

  getAllExerciseList(dateFrom: string, dateTo: string, dlgStatus: FilterDlgStatus, search: string, limit: number, offset: number,
                     sortProp: string, sortDir: string):
    Observable<PagedData<ExerciseDto>> {
    return this.httpClient.get<PagedData<ExerciseDto>>(`${this.baseUrl}/exercise/all/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (dateFrom ? (`&dateFrom=` + encodeURI(dateFrom)) : '') + (dateTo ? (`&dateTo=` + encodeURI(dateTo)) : '') +
      (dlgStatus ? `&dlgStatus=${dlgStatus}` : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getMyExerciseList(dateFrom: string, dateTo: string, dlgStatus: FilterDlgStatus, search: string, limit: number, offset: number,
                    sortProp: string, sortDir: string):
    Observable<PagedData<ExerciseDto>> {
    return this.httpClient.get<PagedData<ExerciseDto>>(`${this.baseUrl}/exercise/my/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (dateFrom ? (`&dateFrom=` + encodeURI(dateFrom)) : '') + (dateTo ? (`&dateTo=` + encodeURI(dateTo)) : '') +
      (dlgStatus ? `&dlgStatus=${dlgStatus}` : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  changeExerciseState(dialogId: number, dialogStatus: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/exercise/change/state`, {dialogId, dialogStatus});
  }

  changeExerciseName(id: number, name: string): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/dialogue/change/name`, {id, name});
  }

  getExerciseForm(dialogId: number): Observable<ExerciseCreateDto> {
    return this.httpClient.get<ExerciseCreateDto>(`${this.baseUrl}/exercise/exercise/form/` + dialogId);
  }

  getServiceExchangeList(exchangeId: number, search: string, limit: number, offset: number,
                         sortProp: string, sortDir: string): Observable<PagedData<ServiceExchangeDto>> {
    return this.httpClient.get<PagedData<ServiceExchangeDto>>(`${this.baseUrl}/service/exchange/list/${exchangeId}?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : ''));
  }

  getServiceExchanges(isUserList: boolean, typeExchangeId: number, customerId: number, search: string, limit: number,
                      offset: number, sortProp: string, sortDir: string): Observable<PagedData<ExchangeDto>> {
    return this.httpClient.get<PagedData<ExchangeDto>>(`${this.baseUrl}/service/exchanges?typeExchangeId=${typeExchangeId}&limit=${limit}&offset=${offset}`
      + (customerId ? `&customerId=${customerId}` : ``)
      + (sortProp ? (`&sortProp=${sortProp}&sortDir=${sortDir}`) : '')
      + (search ? `&search=${encodeURI(search)}` : '')
      + `&isUserList=${isUserList}`);
  }

  getArticleExchanges(isUserList: boolean, typeExchangeId: number, customerId: number, search: string, limit: number,
                      offset: number, sortProp: string, sortDir: string): Observable<PagedData<ExchangeDto>> {
    return this.httpClient.get<PagedData<ExchangeDto>>(`${this.baseUrl}/article/exchanges?typeExchangeId=${typeExchangeId}&limit=${limit}&offset=${offset}`
      + (customerId ? `&customerId=${customerId}` : ``)
      + (sortProp ? (`&sortProp=${sortProp}&sortDir=${sortDir}`) : '')
      + (search ? `&search=${encodeURI(search)}` : '')
      + `&isUserList=${isUserList}`);
  }

  getUserGroups(): Observable<Dictionary[]> {
    return this.httpClient.get<Dictionary[]>(`${this.baseUrl}/user/groups`);
  }

  getConversationDashboard(dateB: string, dateE: string, userGroupId: number): Observable<ConversationDashboardDto> {
    return this.httpClient.get<ConversationDashboardDto>(`${this.baseUrl}/dialogue/conversation/dashboard?userGroupId=` +
      (userGroupId ? userGroupId : 0) + (dateB ? (`&dateB=` + encodeURI(dateB)) : '') + (dateE ? (`&dateE=` + encodeURI(dateE)) : ''));
  }

  getCrisisList(dateB: string, dateE: string, search: string, limit: number, offset: number,
                sortProp: string, sortDir: string, userGroupId: number): Observable<PagedData<CrisisListDto>> {
    return this.httpClient.get<PagedData<CrisisListDto>>(`${this.baseUrl}/dialogue/conversation/list/crisis?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : '') + (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : '') + (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }

  getTeamList(search: string, limit: number, offset: number,
                        sortProp: string, sortDir: string): Observable<PagedData<UserGroupDto>> {
    return this.httpClient.get<PagedData<UserGroupDto>>(`${this.baseUrl}/usergroup/list?limit=` + limit + `&offset=` + offset
      + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') + (search ? (`&search=` + encodeURI(search)) : ''));
  }

  deleteTeam(id: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/usergroup/delete`, id);
  }

  createTeam(userGroupDto: UserGroupDto): Observable<UserGroupDto> {
    return this.httpClient.post<UserGroupDto>(`${this.baseUrl}/usergroup/create`, userGroupDto);
  }

  updateTeam(userGroupDto: UserGroupDto): Observable<UserGroupDto> {
    return this.httpClient.post<UserGroupDto>(`${this.baseUrl}/usergroup/update`, userGroupDto);
  }

  refreshCustomerSettings(): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/customer/refresh`, '');
  }

  getTeam(id): Observable<UserGroupDto> {
    return this.httpClient.get<UserGroupDto>(`${this.baseUrl}/usergroup/` + id);
  }

  getJournalList(dateB: string, dateE: string, search: string, limit: number, offset: number,
                sortProp: string, sortDir: string, userGroupId: number): Observable<PagedData<JournalListDto>> {
    return this.httpClient.get<PagedData<JournalListDto>>(`${this.baseUrl}/journal-list/list?limit=` + limit +
      `&offset=` + offset + (sortProp ? (`&sortProp=` + sortProp + `&sortDir=` + sortDir) : '') +
      (search ? (`&search=` + encodeURI(search)) : '') + (dateB ? (`&dateB=` + encodeURI(dateB)) : '') +
      (dateE ? (`&dateE=` + encodeURI(dateE)) : '') + (userGroupId ? (`&userGroupId=` + userGroupId) : ''));
  }


  getXpeditionScript(xpeditionId: number): Observable<XpeditionScriptDto> {
    return this.httpClient.get<XpeditionScriptDto>(`${this.baseUrl}/xpedition/script/${xpeditionId}`);
  }

  getXpeditionParameters(xpeditionId: number): Observable<ParameterDto[]> {
    return this.httpClient.get<ParameterDto[]>(`${this.baseUrl}/xpedition/parameters/${xpeditionId}`);
  }

  saveXpeditionScript(id: number, sffId: number, name: string, prefix: string,
                      steps: XpeditionScriptStepDto[], rootScript?: string): Observable<NumberResponse> {
      const payload: any = {
        id,
        sffId,
        name,
        prefix,
        steps
      };

    // Only include sffStartaction if provided
      if (rootScript !== undefined) {
        payload.rootScript = rootScript;
      }

      return this.httpClient.post<NumberResponse>(`${this.baseUrl}/xpedition/script/save`, payload);
  }

  saveXpeditionParameters(xpeditionId: number, parameters: ParameterDto[]): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/xpedition/parameters/save`, {
      xpeditionId,
      parameters
    });
  }

  uploadPdfToXpedition(xpeditionPrefix: string, fileName: string, pdfBody: string): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrl}/xpedition/script/extract/pdf`, {
      xpeditionPrefix,
      fileName,
      pdfBody
    });
  }

  consolidateReferences(references: string): Observable<StringResponse> {
    return this.httpClient.post<StringResponse>(`${this.baseUrl}/article/consolidate/references`, references);
  }

  createBotUser(userDto: UserDto): Observable<UserDto> {
    return this.httpClient.post<UserDto>(`${this.baseUrl}/user/create`, userDto);
  }

}
